<template>
  <div>
    <div v-if="$i18n.locale === 'pl'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Polityka prywatności danych</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. INFORMACJE OGÓLNE</p>
                <p>
                  Nissens zobowiązuje się do zapewnienia poufności, integralności i ochrony informacji
                  pochodzących od naszych pracowników, klientów, dostawców i innych partnerów biznesowych,
                  w tym ich danych osobowych.
                </p>
                <p class="semi-bold my-4 py-3">2. ZBIERANIE I PRZETWARZANIE DANYCH OSOBOWYCH PRZEZ NISSENS</p>
                <p>Nissens jest odpowiedzialny jako administrator danych osobowych podczas ich gromadzenia.</p>
                <p>
                  a. Informacje ogólne<br>
                  Nissens gromadzi dane osobowe, w tym informacje o nazwiskach, tytułach, adresach, numerach
                  telefonów, adresach e-mail i innych danych identyfikacyjnych dotyczących klientów, dostawców,
                  oraz osób trzecich. Nissens gromadzi historię sprzedaży i zakupów oraz rejestry szkoleń.<br>
                  Nissens może gromadzić informacje o cechach finansowych, takie jak numery kont i dane bankowe,
                  paszporty (kopie paszportów), ograniczone do odpowiednich przepisów lub celów. Tego rodzaju
                  informacje będą przechowywane pod zwiększonym bezpieczeństwem i kontrolą.
                </p>
                <p class="text-underline">Platformy cyfrowe</p>
                <p>
                  Na stronach internetowych należących do Nissens, w sklepie internetowym oraz za pośrednictwem newsletterów
                  (wyłącznie za zgodą) gromadzone są informacje:
                </p>
                <ul>
                  <li>Które strony odwiedzający przeglądał i w jakim terminie</li>
                  <li>Z jakiej przeglądarki korzysta odwiedzający</li>
                  <li>Jaki adres IP ma odwiedzający</li>
                  <li>Nazwa użytkownika odwiedzającego</li>
                </ul>
                <p>Żadne inne informacje nie są gromadzone, chyba że odwiedzający zostanie o tym powiadomiony.</p>
                <p>b. HR</p>
                <p>
                  Nissens nie gromadzi danych osobowych, które mają charakter wysoce wrażliwych danych, takich
                  jak pochodzenie rasowe lub etniczne, poglądy polityczne, przekonania religijne lub światopoglądowe,
                  dane biometryczne, dane genetyczne, orientacja seksualna, przeszłość kryminalna lub relacje społeczne.
                </p>
                <p>
                  Nissens gromadzi wyłącznie dane osobowe, w jasnych, określonych i przejrzystych celach, takich jak
                  członkostwo w związkach zawodowych, informacje dotyczące zdrowia i inne ściśle istotne informacje
                  dotyczące relacji i obowiązków na linii pracodawca-pracownik.
                </p>
                <p>
                  W odniesieniu do pracowników, osób aplikujących oraz emerytów, Nissens gromadzi dane osobowe, takie
                  jak imiona i nazwiska, numery ewidencyjne, tytuły, adresy, numery telefonów, adresy e-mail, życiorysy,
                  podania, wykształcenie dokumentacja, transkrypcje akt, oświadczenia/rekomendacje, testy osobowości,
                  zdjęcia i filmy (gdzie występuje osoba), streszczenia ocen pracowników, informacje o wynagrodzeniu i
                  podatkach (jeżeli jest to wymagane przez prawo), informacje dotyczące emerytury, ubezpieczenia
                  społecznego, jak również informacje dotyczące miejsca przebywania. W takich przypadkach dane są
                  objęte zwiększoną poufnością i kontrolą w działach kadr i finansów firmy Nissens.
                </p>
                <p>
                  Aby uzyskać więcej informacji na temat ochrony danych osobowych w procesach rekrutacyjnych Nissens,
                  prowadzonych przez Nissens, prosimy o kontakt z działem HR.
                </p>
                <p class="semi-bold my-4 py-3">3. ZGODY</p>
                <p>
                  Nissens zbiera i przetwarza dane osobowe zgodnie z odpowiedną podstawą prawną.<br>
                  Dane osobowe są gromadzone bez Twojej zgody, w przypadku stwierdzenia zgodności z prawem przetwarzania
                  danych, z zachowaniem równowagi pomiędzy prawami odwiedzającego a uzasadnionym interesem Nissens.<br>
                  Jeśli zgoda jest konieczna ze względu na przepisy, Nissens prosi o wyraźną i przejrzystą zgodę przed
                  rejestracją i przetwarzaniem. Zgodę można wycofać równie łatwo, jak ją wyrażono.
                </p>
                <p class="semi-bold my-4 py-3">4. CEL ZBIERANIA I PRZETWARZANIA DANYCH OSOBOWYCH</p>
                <p>
                  Nissens gromadzi i przetwarza dane osobowe w celu wspierania prawnych i uzasadnionych interesów handlowych Nissens:
                </p>
                <p>a. Informacje ogólne</p>
                <ul>
                  <li>
                    Spełnienie przepisów i wymagań władz publicznych, w tym ustaw o rachunkowości i ustaw o rachunkowości,
                    podatku VAT i przepisów podatkowych.
                  </li>
                  <li>
                    Informacje niezbędne do wypełnienia umów Nissens z klientami, dostawcami i stronami trzecimi, w tym
                    dostarczania i odbierania określonego produktu lub usług, faktur i kontroli jakości.
                  </li>
                  <li>Kontrolowanie i wzmacnianie relacji z obecnymi i potencjalnymi klientami, dostawcami i stronami trzecimi.</li>
                  <li>
                    Rozwijanie działalności i usług Nissens poprzez identyfikację potrzeb klientów i pożądane ulepszenia naszych usług.
                  </li>
                  <li>
                    Podejmowanie przetwarzania statystycznego, rozwoju biznesu i promocji sprzedaży zgodnie z
                    obowiązującymi przepisami prawa.
                  </li>
                  <li>
                    Administrowanie i kontrolowanie stron internetowych, sklepu internetowego, biuletynów, systemów i aplikacji Nissens
                    oraz poprzez pobieranie danych z tych kanałów w celu realizacji powyższych celów.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>Przestrzegania prawa pracy, w tym warunków i zobowiązań umownych.</li>
                  <li>Informacje niezbędne do wypełnienia umowy o pracę z osobą, której dane dotyczą (pracownikiem).</li>
                  <li>Informacje niezbędne do prawidłowego i zgodnego z prawem wykonywania uprawnień zarządczych.</li>
                  <li>
                    Niezbędne informacje wspierające zatrudnienie pracownika w Nissens oraz rozwój pracownika,
                    w tym ogólne środowisko pracy.
                  </li>
                  <li>Informacje niezbędne do oceny, czy kandydat nadaje się do pracy w Nissens.</li>
                  <li>W celu spełnienia obowiązujących przepisów i wymogów sprawozdawczych.</li>
                  <li>
                    Informacje dotyczące wykorzystania rekrutacji i utrzymania pracowników w Nissens, w tym budowanie
                    wizerunku marki pracodawcy.
                  </li>
                  <li>W celu wypełnienia sprawozdawczości CSR.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. PRZEKAZYWANIE DANYCH OSOBOWYCH</p>
                <p>a. <span class="text-underline">Udostępnianie w Grupie Nissens</span></p>
                <p>
                  Nissens to duńska grupa z siedzibą w Horsens w Danii, która składa się z wielu spółek zależnych
                  (jednostek indywidualnych) w UE/EOG i poza nią.<br>
                  Nissens w Danii i centrala udostępniają dane osobowe innym firmom Nissens, gdy jest to konieczne
                  do realizacji celów wymienionych w punkcie 4.<br>
                  W rezultacie dane osobowe mogą być przekazywane do innych krajów na terenie UE/EOG oraz poza nią.
                  Aby udostępniać dane w ramach Grupy Nissens, umowy zawierane są na podstawie wzorców umownych
                  Komisji Europejskiej w celu zapewnienia odpowiedniego poziomu ochrony danych osobowych.
                </p>
                <p>b. <span class="text-underline">Udostępnianie osobom trzecim</span></p>
                <p>Nissens udostępnia dane osobowe w poniższych przypadkach:</p>
                <ul>
                  <li>
                    W celu realizacji umów z klientami, dostawcami i osobami trzecimi; w celu realizacji umów Nissens
                    (na przykład dystrybutorów i przewoźników) oraz w celu spełnienia wymogów prawnych i regulacyjnych.
                  </li>
                  <li>
                    Osoby trzecie, które jako usługodawca wspierają Nissens rozwiązaniami (na przykład rozwiązaniami IT)
                    oraz dostawcy świadczący usługi konsultingowe.
                  </li>
                  <li>
                    Nissens zawiera umowy wyłącznie z profesjonalnymi dostawcami, których stale ocenia, zapewniając,
                    że mogą utrzymywać i zabezpieczać dane osobowe na odpowiednim poziomie ochrony.
                  </li>
                  <li>
                    Gdy strona trzecia przetwarza dane w imieniu Nissens, jako administratora danych, pomiędzy
                    Nissens a podmiotem przetwarzającym dane zostaje zawarta umowa dotycząca przetwarzania danych.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Sprzedaż danych osobowych</span></p>
                <p>Nissens nie sprzedaje osobom trzecim danych osobowych.</p>
                <p class="semi-bold my-4 py-3">6. OCHRONA</p>
                <p>
                  Nissens stale aktualizuje i ulepsza wdrożone środki techniczne i organizacyjne, aby zapewnić że
                  gromadzenie, przechowywanie, przetwarzanie i usuwanie danych osobowych odbywa się zgodnie z
                  obowiązującymi przepisami i niniejszą polityką. Środki te mają na celu zapobieganie przypadkowemu
                  lub niezgodnemu z prawem zniszczeniu, zmianie lub pogorszeniu danych osobowych oraz uniemożliwieniu
                  dostępu do nich osobom nieuprawnionym.<br>
                  Dostęp ten uzyskują wyłącznie pracownicy, którzy mają konieczność dostępu do przechowywanych danych
                  osobowych zgodnie ze swoimi uprawnieniami i odpowiedzialnością za wypełnianie obowiązków służbowych.
                </p>
                <p class="semi-bold my-4 py-3">7. USUWANIE DANYCH OSOBOWYCH</p>
                <p>
                  Dane osobowe są usuwane wówczas, gdy Nissens nie ma już potrzeby przetwarzania danych. Okres
                  przechowywania danych osobowych jest określany zgodnie z obowiązującym prawem oraz niezbędnymi
                  do realizacji umów z partnerami biznesowymi, a także udokumentowania istotnych informacji w
                  ewentualnych sprawach reklamacyjnych i innych podniesionych przeciwko lub przez Nissens roszczeń.
                </p>
                <p class="semi-bold my-4 py-3">8. TWOJE PRAWA</p>
                <p>
                  Jako osoba fizyczna masz określone prawa do swoich danych osobowych.<br>
                  Możesz skontaktować się z Nissens i uzyskać pożądany wgląd w to, jakie dane osobowe na Twój temat
                  przetwarza Nissens, podobnie jak masz prawo do poprawienia wszelkich niedokładnych lub
                  nieodpowiednich danych. Jeśli chcesz usunąć dane osobowe, ograniczyć przetwarzanie lub
                  zgłosić sprzeciw wobec przetwarzania, możesz skontaktować się z Nissens. Ponadto, jeśli
                  chcesz skorzystać z prawa do przenoszenia danych, również skontaktuj się z nami.<br>
                  Pytania dotyczące przetwarzania danych osobowych przez Nissens lub ogólnej polityki prywatności należy
                  kierować na adres e-mail: <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  or <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. ZMIANY W POLITYCE PRYWATNOŚCI DANYCH NISSENS</p>
                <p>
                  Nissens przyjmuje do wiadomości odpowiedzialność za regularne przeglądanie i wprowadzanie ulepszeń
                  i zmian w polityce prywatności danych, w szczególności w celu dalszego zapewniania niezbędnego
                  bezpieczeństwa zgodnie z rozwojem środowiska IT. Nissens będzie regularnie przeprowadzał wewnętrzne
                  działania kontrolne i aktualizował niniejszą politykę prywatności danych, aby zapewnić zgodność z
                  obowiązującymi przepisami.
                </p>
                <p class="semi-bold my-4 py-3">10. ZGODA NA KOMUNIKACJĘ</p>
                <p>
                  Użytkownicy, którzy chcą zarejestrować swoje konto na platformach internetowych należących do Nissens,
                  w tym na stronie support.nissens.com, podczas rejestracji muszą wyrazić zgodę dotyczącą potencjalnej
                  komunikacji, która może być rozpowszechniana wśród zarejestrowanych użytkowników platformy.
                </p>
                <p>Zgoda dotyczy następujących form komunikacji:</p>
                <p>Komunikacja marketingowa</p>
                <p>
                  Użytkownicy zgadzają się na otrzymywanie komunikatów marketingowych od Nissens Automotive A/S dotyczących
                  ich produktów i usług, nowości produktowych, premier i aktualizacji, a także specjalnych promocji, ofert
                  i wydarzeń wysyłanych do użytkowników pocztą elektroniczną.
                </p>
                <p>Kontakt bezpośredni</p>
                <p>
                  Użytkownicy wyrażają zgodę na bezpośredni kontakt telefoniczny z Nissens Automotive A/S lub z lokalnymi
                  pracownikami filii Nissens w przypadku, gdy został podany adres e-mail lub numer telefonu podczas
                  procesu rejestracji w przypadku wygrania w grach i konkursach publikowanych na platformie.
                </p>
                <p>Komunikacja serwisowa</p>
                <p>
                  Zakładając konto na platformie użytkownicy wyrażają zgodę na otrzymywanie e-maili serwisowych oraz
                  na kontakt poprzez inne środki komunikacji w zakresie praktycznych i technicznych aspektów
                  działalności w ramach platformy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Oświadczenie</h2>
              <div class="text-md">
                <p>
                  Dołożono wszelkich możliwych starań, aby zapewnić, że przedstawione tu informacje szkoleniowe są
                  prawidłowe na dzień ich publikacji. Nissens Automotive A/S nie ponosi jednak odpowiedzialności
                  za błędy obliczeniowe czy nieścisłości. Materiały i treści zawarte w niniejszym materiale
                  szkoleniowym są udostępniane bez jakiejkolwiek gwarancji. Zalecamy zawsze przestrzegać zaleceń
                  zawartych w instrukcji producenta danego pojazdu, w której opisano przykładowy sposób wykonania
                  czynności serwisowych i obsługowych. Nissens Automotive A/S nie ponosi odpowiedzialności za
                  żadne uszkodzenie mienia ani obrażenia ciała, bezpośrednie albo pośrednie szkody spowodowane
                  awarią albo przestojem pojazdu wynikającym z wykorzystania informacji przedstawionych w
                  niniejszym materiale szkoleniowym albo z nieprawidłowego zastosowania, montażu lub
                  użytkowania naszych produktów.
                </p>
                <p>
                  Narzędzia i pojazdy przedstawione w niniejszym materiale szkoleniowym wykorzystano wyłącznie w
                  celach szkoleniowych. Publikując niniejszy materiał szkoleniowy, Nissens Automotive A/S nie
                  rości sobie żadnych praw własności intelektualnej producenta przedstawionych narzędzi,
                  materiałów eksploatacyjnych i pojazdów, w szczególności do nazwy ich marki i modelu, znaków
                  towarowych, systemów bądź części ani ich unikalnych cech.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Kontakt</h2>
              <div class="text-md">
                <p>
                  Strona i jej zawartość jest własnością Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, Wszelkie prawa zastrzeżone.
                </p>
                <p>
                  W przypadku pytań prosimy o kontakt
                </p>
                <p>
                  Nissens Global Marketing<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'it'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Informativa sulla privacy dei dati</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. GENERALE</p>
                <p>
                  Nissens si impegna a garantire la riservatezza, l'integrità e la protezione delle informazioni
                  dei nostri dipendenti, clienti, fornitori e altri partner commerciali, compresi i loro dati
                  personali (di seguito denominati voi)
                </p>
                <p class="semi-bold my-4 py-3">2. DATI PERSONALI RACCOLTI ED ELABORATI DA NISSENS</p>
                <p>Nissens è responsabile come responsabile del trattamento dei dati quando raccoglie dati personali.</p>
                <p>
                  a. Generale<br>
                  Nissens è responsabile come responsabile del trattamento dei dati quando raccoglie dati personali.<br>
                  Nissens può raccogliere informazioni su caratteristiche finanziarie come numeri di conto e coordinate
                  bancarie, passaporti (copia dei passaporti) e numeri di registrazione civile, ma limitatamente a
                  ove necessario in base alla legislazione o in base allo scopo pertinente. Questa natura delle
                  informazioni sarà conservata sotto maggiore sicurezza e controllo.
                </p>
                <p class="text-underline">Su piattaforme digitali</p>
                <p>
                  Sui siti Web di proprietà di Nissens, nel negozio online di Nissens e tramite newsletter (solo con il
                  consenso) vengono raccolte informazioni:
                </p>
                <ul>
                  <li>Quali siti ha visitato il visitatore, quando e quindi le tracce del visitatore.</li>
                  <li>Quale browser sta utilizzando il visitatore</li>
                  <li>Quale indirizzo IP ha il visitatore</li>
                  <li>Il nome utente del visitatore</li>
                </ul>
                <p>Nessun'altra informazione viene raccolta a meno che non venga fornita una notifica trasparente al visitatore.</p>
                <p>b. HR</p>
                <p>
                  Nissens non raccoglie dati personali, che hanno il carattere di informazioni personali altamente sensibili,
                  come l'origine razziale o etnica, le opinioni politiche, le convinzioni religiose o filosofiche, i dati
                  biometrici, i dati genetici, l'orientamento sessuale, la fedina penale o le relazioni sociali.
                </p>
                <p>
                  Nissens raccoglie solo informazioni personali, che hanno il carattere di informazioni personali semi-sensibili
                  per scopi chiari, definiti e trasparenti, come l'iscrizione a sindacati, informazioni sanitarie e altre
                  informazioni strettamente pertinenti pertinenti al rapporto e alle responsabilità datore di lavoro-dipendente.
                </p>
                <p>
                  Per quanto riguarda i dipendenti, candidati per posizioni lavorative presso Nissens, nonché dipendenti in
                  pensione, Nissens raccoglie informazioni personali, come nomi, numeri di registrazione civile, titoli,
                  indirizzi, numeri di telefono, indirizzi e-mail, CV, candidature, istruzione documentazione, trascrizioni
                  di atti, dichiarazioni/raccomandazioni, test della personalità, foto e filmati (in cui la persona è presente),
                  riepiloghi delle valutazioni delle prestazioni sui dipendenti, informazioni salariali e fiscali (quando
                  richiesto dalla normativa), informazioni relative alla pensione, anche alla sicurezza sociale come
                  informazioni di viaggio. In questi casi, i dati sono soggetti a maggiore riservatezza e controllo all'interno
                  dei dipartimenti Risorse umane e finanziari di Nissens.
                </p>
                <p>
                  Per ulteriori informazioni sulla protezione dei tuoi dati personali nei processi di reclutamento di Nissens,
                  contatta il dipartimento delle risorse umane di Nissens.
                </p>
                <p class="semi-bold my-4 py-3">3. CONSENSO</p>
                <p>
                  Nissens raccoglie ed elabora informazioni personali solo sulla base giuridica pertinente.<br>
                  Le informazioni personali sono raccolte senza il tuo consenso, laddove sia dichiarata una liceità
                  del trattamento, di seguito con un bilanciamento degli interessi dei tuoi diritti e dell'interesse
                  legittimo di Nissens.
                </p>
                <p class="semi-bold my-4 py-3">4. FINALITÀ DEI DATI PERSONALI RACCOLTI E TRATTATI</p>
                <p>
                  Nissens raccoglie ed elabora i dati personali solo quando c'è uno scopo per la raccolta per sostenere
                  gli interessi commerciali legali e legittimi di Nissens:
                </p>
                <p>a. Generale</p>
                <ul>
                  <li>Per l'adempimento della normativa e degli adempimenti delle pubbliche autorità, ivi
                    compresi atti contabili e atti contabili, IVA e normativa tributaria.
                  </li>
                  <li>
                    Le informazioni necessarie per adempiere agli accordi di Nissens con clienti, fornitori e terze parti, inclusa la
                    consegna e la ricezione del prodotto e/o dei servizi specificati, le fatture e il controllo di qualità.
                  </li>
                  <li>Controllare e rafforzare il rapporto con clienti, fornitori e terze parti esistenti e potenziali.</li>
                  <li>
                    Sviluppare l'attività ei servizi di Nissens identificando le esigenze dei clienti e i miglioramenti desiderati
                    dei nostri servizi.
                  </li>
                  <li>
                    Effettuare l'elaborazione statistica, lo sviluppo del business e la promozione delle vendite nel rispetto
                    delle leggi applicabili.
                  </li>
                  <li>
                    Amministrazione e controllo dei siti Web, del negozio online, delle newsletter, dei sistemi e delle applicazioni
                    di Nissens e tramite il recupero dei dati da questi canali per supportare le finalità di cui sopra.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>All'adempimento del diritto del lavoro, comprese le condizioni e gli obblighi contrattuali.</li>
                  <li>Le informazioni necessarie a Nissens per adempiere al contratto di lavoro con l'interessato (dipendente).</li>
                  <li>Le informazioni necessarie per esercitare in modo appropriato e legale i diritti di gestione.</li>
                  <li>
                    Le informazioni necessarie per supportare l'impiego del dipendente presso Nissens e il benessere e lo sviluppo
                    del dipendente, compreso l'ambiente di lavoro in generale.
                  </li>
                  <li>Le informazioni necessarie per giudicare se un candidato è idoneo per una posizione lavorativa in Nissens.</li>
                  <li>Per l'adempimento della normativa applicabile e degli obblighi di segnalazione delle autorità pubbliche.</li>
                  <li>
                    Informazioni per l'utilizzo del reclutamento e della fidelizzazione dei dipendenti presso Nissens,
                    incluso il marchio del datore di lavoro.
                  </li>
                  <li>Per l'adempimento della rendicontazione CSR.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. TRASMISSIONE DEI DATI PERSONALI</p>
                <p>a. <span class="text-underline">Condivisione con il gruppo Nissens</span></p>
                <p>
                  Nissens è un gruppo di proprietà danese con sede a Horsens, Danimarca, e costituisce una serie di filiali
                  (unità giuridiche individuali) all'interno e all'esterno dell'UE/SEE.<br>
                  Nissens in Danimarca e la sede centrale condividono i dati personali con altre società Nissens,
                  quando è necessario per soddisfare le finalità menzionate nella sezione 4.<br>
                  Di conseguenza, i dati personali possono essere trasferiti ad altri paesi all'interno e all'esterno
                  dell'UE/SEE. Per condividere i dati all'interno del Gruppo Nissens, vengono stipulati accordi basati
                  sui contratti standard della Commissione Europea allo scopo di garantire un livello adeguato di
                  protezione dei dati personali.
                </p>
                <p>b. <span class="text-underline">Condivisione con terze parti</span></p>
                <p>
                  Nissens sta trasmettendo informazioni personali a terzi:
                </p>
                <ul>
                  <li>
                    Per l'adempimento di accordi con clienti, fornitori e terzi; per l'adempimento degli accordi di
                    Nissens (ad esempio distributori e vettori) e per l'adempimento dei requisiti legislativi e regolamentari.
                  </li>
                  <li>
                    Terze parti, che in qualità di fornitore di servizi assistono Nissens con soluzioni (ad esempio soluzioni IT)
                    e fornitori che forniscono consulenza.
                  </li>
                  <li>
                    Nissens stipula accordi solo con fornitori professionali, che Nissens valuta continuamente, assicurandosi
                    che possano mantenere e proteggere i dati personali di Nissens a un livello di protezione adeguato.
                  </li>
                  <li>
                    Quando una terza parte elabora dati per conto di Nissens in qualità di titolare del trattamento dei dati,
                    viene stipulato un accordo per il responsabile del trattamento dei dati tra Nissens e il responsabile
                    del trattamento dei dati.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Vendita di dati personali</span></p>
                <p>Nissens non rende i dati personali oggetto o disponibili per la vendita a terzi.</p>
                <p class="semi-bold my-4 py-3">6. SICUREZZA</p>
                <p>
                  Nissens ha e aggiornerà e migliorerà continuamente le misure tecniche e organizzative
                  adeguate implementate per garantire ed essere in grado di dimostrare che la raccolta,
                  l'archiviazione, l'elaborazione e la cancellazione dei dati personali sono eseguite in
                  conformità con la legislazione applicabile e questa politica. Tali misure sono adottate
                  per prevenire la distruzione, la modifica o il deterioramento accidentale o illegale dei
                  dati personali e l'accesso di persone non autorizzate ai dati personali.<br>
                  Solo i dipendenti con un'effettiva necessità di accesso ai dati personali archiviati in
                  base alla loro capacità e responsabilità di adempiere ai propri obblighi di lavoro ottengono tale accesso.
                </p>
                <p class="semi-bold my-4 py-3">7. CANCELLAZIONE DATI PERSONALI</p>
                <p>
                  Nissens sta eliminando i dati personali, quando Nissens non ha più la necessità professionale
                  di elaborare i dati personali. Il periodo di conservazione dei dati personali è determinato
                  in base agli obblighi disciplinati dalla legislazione vigente e da quanto necessario per
                  adempiere agli accordi con i partner commerciali nonché per documentare le informazioni
                  rilevanti in potenziali casi di reclamo e altri reclami avanzati nei confronti o da parte di Nissens.
                </p>
                <p class="semi-bold my-4 py-3">8. I TUOI DIRITTI</p>
                <p>
                  Puoi contattare Nissens e ottenere le informazioni desiderate su quali informazioni personali
                  che Nissens sta elaborando su di te, così come hai diritto alla rettifica di dati imprecisi o
                  inadeguati. Se si desidera che le informazioni personali vengano cancellate, limitare il
                  trattamento o opporsi al trattamento, è possibile contattare Nissens per un dialogo. Puoi
                  inoltre contattare Nissens, se desideri sfruttare il diritto alla portabilità dei dati.<br>
                  Le domande sul trattamento dei dati personali da parte di Nissens o sull'informativa sulla
                  privacy in generale devono essere indirizzate all'e-mail:
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  o <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. MODIFICHE ALL'INFORMATIVA SULLA PRIVACY DEI DATI DI NISSENS</p>
                <p>
                  Nissens riconosce la responsabilità di rivedere regolarmente e apportare miglioramenti e
                  adeguamenti alla politica sulla privacy dei dati, in particolare per continuare a fornire
                  la sicurezza necessaria in linea con lo sviluppo dell'ambiente IT. Nissens eseguirà regolarmente
                  il follow-up interno e l'aggiornamento di questa politica sulla privacy dei dati per garantire
                  la conformità con la legislazione applicabile.
                </p>
                <p class="semi-bold my-4 py-3">10. CONSENSO ALLA COMUNICAZIONE</p>
                <p>
                  Gli utenti che desiderano registrare il proprio account sulle piattaforme di proprietà di
                  Nissens e incluso il sito Web support.nissens.com, nel processo di registrazione devono
                  accettare di ricevere l'eventuale comunicazione che potrebbe essere distribuita agli utenti
                  registrati della piattaforma.
                </p>
                <p>Il consenso riguarda i seguenti moduli di comunicazione:</p>
                <p>Comunicazione di marketing</p>
                <p>
                  Gli utenti accettano di ricevere comunicazioni di marketing da Nissens Automotive A/S sui
                  loro prodotti e servizi, novità sui prodotti, lanci e aggiornamenti, nonché su promozioni
                  speciali, offerte e/o eventi inviati agli utenti tramite e-mail.
                </p>
                <p>Contatto diretto</p>
                <p>
                  Gli utenti accettano di essere contattati direttamente da Nissens Automotive A/S o/e dai
                  dipendenti delle consociate locali nel caso in cui abbiano fornito la propria e-mail o numero
                  di telefono durante il processo di registrazione in caso di vincita da giochi e concorsi
                  pubblicati sulla piattaforma.
                </p>
                <p>Comunicazione di servizio</p>
                <p>
                  Creando un account sulla piattaforma gli utenti accettano di ricevere e-mail di servizio e
                  di essere contattati con altri mezzi per quanto riguarda gli aspetti pratici e tecnici della
                  loro attività all'interno della piattaforma.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Disconoscimento</h2>
              <div class="text-md">
                <p>
                  È stato fatto ogni possibile sforzo e sforzo per garantire che queste informazioni di
                  apprendimento siano corrette alla data di emissione. Nissens Automotive A/S, tuttavia,
                  declina ogni responsabilità per errori di calcolo o imprecisioni. I materiali e i contenuti
                  di questo apprendimento sono forniti senza garanzie di alcun tipo. Raccomandiamo di seguire
                  sempre le istruzioni fornite dal produttore del veicolo per rispettare le procedure di
                  assistenza e manutenzione esemplari. Nissens Automotive A/S non sarà ritenuta responsabile
                  per eventuali danni alla proprietà o lesioni personali, danni diretti o indiretti, dovuti
                  a guasti o tempi di fermo nel funzionamento del veicolo causati dall'uso delle informazioni
                  fornite in questo apprendimento o da applicazione, installazione e / o abuso dei nostri prodotti.
                </p>
                <p>
                  Gli strumenti ei veicoli presentati nei materiali didattici condivisi sono stati utilizzati
                  esclusivamente per scopi didattici. Pubblicando questo materiale didattico, Nissens Automotive
                  A/S non rivendica alcun diritto sulla proprietà intellettuale del produttore degli strumenti,
                  dei materiali di consumo e del veicolo presentati, e in particolare sul nome della marca e del
                  modello, sui marchi, sui sistemi o sulle parti o sulle loro caratteristiche uniche .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Contatti</h2>
              <div class="text-md">
                <p>
                  La pagina e i suoi contenuti appartengono a Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, Tutti i diritti riservati.
                </p>
                <p>
                  Per ulteriori domande, si prega di contattare
                </p>
                <p>
                  Marketing globale Nissens<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'de'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Datenschutzbestimmungen</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. ALLGEMEINES</p>
                <p>
                  Nissens verpflichtet sich, die Vertraulichkeit, die Integrität und den Schutz der
                  Informationen unserer Mitarbeiter, Kunden, Lieferanten und anderer Geschäftspartner
                  zu gewährleisten, einschließlich ihrer persönlichen Daten (im Folgenden als Sie bezeichnet).
                </p>
                <p class="semi-bold my-4 py-3">2. VON NISSENS ERHOBENE UND VERARBEITETE PERSÖNLICHE DATEN</p>
                <p>Bei Datenerhebung agiert Nissen als Datenverantwortlicher.</p>
                <p>
                  a. Allgemeines<br>
                  Nissens speichert persönliche Daten, einschließlich Informationen über Namen, Titel, Adressen,
                  Telefonnummern, E-Mail-Adressen und andere Identifikationsdaten in Bezug auf Kunden, Lieferanten,
                  Dritte, deren Eigentümer und Kontaktpersonen. Nissens sammelt Verkaufs- und Kaufhistorie
                  und Schulungsunterlagen.<br>
                  Nissens kann Informationen über finanzielle Daten wie Kontonummern und Bankverbindungen, Reisepässe
                  (Kopien von Reisepässen) und Personenstandsnummern sammeln, aber nur dort, wo die Gesetzeslage
                  erfordert oder aufgrund des relevanten Zwecks. Diese Art von Information wird unter verstärkter
                  Sicherheit und Kontrolle gespeichert.
                </p>
                <p class="text-underline">Auf digitalen Plarttformen</p>
                <p>Auf Webseiten von Nissens, im Nissens Webshop und via Newsletter (nur mit Zustimmung) werden folgende Daten erhoben:</p>
                <ul>
                  <li>Welche Seiten der Nutzer wann besucht hat, damit die Spur des Nutzers</li>
                  <li>Welchen Browser der Nutzer benutzt</li>
                  <li>Die IP-Adresse des Nutzers</li>
                  <li>Der Benutzername des Nutzers</li>
                </ul>
                <p>
                  Es werden keine sonstigen Informationen erhoben, es sei denn, dass dies durch eine deutlich
                  erkennbare Meldung mitgeteilt wird
                </p>
                <p>b. HR</p>
                <p>
                  Nissens speichert keine sensiblen personenbezogenen Daten, wie etwa rassische oder ethnische Herkunft,
                  politische Meinungen, religiöse oder philosophische weltanschauliche Überzeugungen, biometrische Daten
                  zur eindeutigen Identifizierung einer natürlichen Person, Gesundheitsdaten, Daten zur sexuellen Orientierung,
                  Strafregister oder sonstiger persönlicher Beziehungen.
                </p>
                <p>
                  Nissens sammelt nur persönliche Informationen, die nur zu einem gewissen Grad sensibel sind, für klare,
                  definierte und transparente Zwecke, wie z.B. Gewerkschaftsmitgliedschaften, Gesundheitsinformationen
                  und andere streng relevante Informationen, die für die Beziehung zwischen Arbeitgeber und Arbeitnehmer
                  und deren Verantwortlichkeiten relevant sind.
                </p>
                <p>
                  In Bezug auf Angestellte, Kandidaten, die sich für eine Stelle bei Nissens bewerben oder in Erwägung
                  ziehen, sowie pensionierte Angestellte, sammelt Nissens persönliche Daten, wie Namen, Standesamtsnummern,
                  Titel, Adressen, Telefonnummern, E-Mail-Adressen, Lebensläufe, Bewerbungen, Ausbildungsunterlagen,
                  Abschriften von Zeugnissen, Aussagen/Empfehlungen, Persönlichkeitstests, Fotos und Filme (wenn die
                  Person abgebildet ist), Zusammenfassungen von Leistungsbeurteilungen über Angestellte, Gehalts-
                  und Steuerinformationen (wenn dies gesetzlich vorgeschrieben ist), Informationen über Rente,
                  Sozialversicherung sowie Reiseinformationen. In diesen Fällen unterliegen die Daten einer verstärkten
                  Vertraulichkeit und Kontrolle innerhalb der zuständigen Personal- und Finanzabteilungen von Nissens.
                </p>
                <p>
                  Für mehr Informationen zum Datenschutz während des Einstellungsprozesses kontaktieren
                  Sie bitte die Nissens HR Abteilung.
                </p>
                <p class="semi-bold my-4 py-3">3. EINWILLIGUNG</p>
                <p>
                  Nissens erhebt und verarbeitet personenbezogene Daten nur auf entsprechenden Rechtsgrundlagen.<br>
                  Persönliche Informationen werden ohne eine Zustimmung von Ihnen gesammelt, wo die Rechtmäßigkeit
                  der Verarbeitung gegeben ist, hierunter mit einer Abwägung der Interessen der Rechte von Ihnen
                  und Nissens berechtigten Interesse gemacht wird.
                </p>
                <p class="semi-bold my-4 py-3">4. Zweck der Datenerhebung und -verarbeitung personenbezogener Daten</p>
                <p>
                  Nissens sammelt und verarbeitet persönliche Daten nur, wenn ein Zweck für die Sammlung gegeben ist,
                  um die gesetzlichen und berechtigten kommerziellen Interessen von Nissens zu unterstützen:
                </p>
                <p>a. Allgemeines</p>
                <ul>
                  <li>Zur Erfüllung von Gesetzen und behördlichen Auflagen, einschließlich Buchführungsgesetzen und
                    Gesetzen zur Buchführung, Mehrwertsteuer und Steuergesetzen.
                  </li>
                  <li>
                    Die notwendigen Informationen, um die Vereinbarungen von Nissens mit Kunden, Lieferanten und Dritten
                    zu erfüllen, einschließlich der Lieferung und des Empfangs des bestimmten Produkts und/oder der
                    Dienstleistungen, Rechnungen und Qualitätskontrolle.
                  </li>
                  <li>
                    Die Geschäftsbeziehungen zu neuen und potentiellen Kunden, Lieferanten und Dritten zu kontrollieren und zu stärken.
                  </li>
                  <li>
                    Das Geschäft und die Dienstleistungen von Nissens mit einer Identifizierung der Kundenbedürfnisse
                    und der gewünschten Verbesserungen unserer Dienstleistungen zu entwickeln.
                  </li>
                  <li>
                    Die statistische Verarbeitung, die Geschäftsentwicklung und die Verkaufsförderung unter
                    Einhaltung der geltenden Gesetze durchzuführen.
                  </li>
                  <li>
                    Verwaltung und Kontrolle der Nissens-Webseiten, des Webshops, der Newsletter, der Systeme und
                    Anwendungen und durch das Abrufen von Daten aus diesen Kanälen zur Unterstützung der oben genannten Zwecke.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>Zur Einhaltung des arbeitsrechtlicher Bestimmungen, einschließlich vertraglicher Bedingungen und Pflichten.</li>
                  <li>
                    Die notwendigen Informationen für Nissens um die mit dem Betroffenen (Angestellten) geschlossene
                    Vereinbarung einzuhalten.
                  </li>
                  <li>Die notwendigen Informationen, um angemessen und rechtmäßig Direktionsrechte auszuüben.</li>
                  <li>
                    Die notwendigen Informationen, um die Beschäftigung des Arbeitnehmers bei Nissens und das Wohlergehen und
                    die Entwicklung des Arbeitnehmers zu unterstützen, einschließlich der Arbeitsumgebung im Allgemeinen.
                  </li>
                  <li>Die notwendigen Informationen, um zu entscheiden, ob ein Kandidat geeignet für eine Stelle bei Nissens ist.</li>
                  <li>Für die Einhaltung anwendbaren Rechts und behördlicher Anforderungen an die Berichtserstellung.</li>
                  <li>
                    Informationen für die Einstellung und Weiterbeschäftigung von Mitarbeitern bei Nissens, einschließlich
                    Employer Branding.
                  </li>
                  <li>Für die Durchführung der CSR-Berichterstattung.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. WEITERGABE PERSONENBEZOGENER DATEN</p>
                <p>a. <span class="text-underline">Teilen mit Nissens Group</span></p>
                <p>
                  Nissens ist ein dänischer Konzern mit Hauptsitz in Horsens, Dänemark, und besteht aus
                  einer Reihe von Tochtergesellschaften (einzelne rechtliche Einheiten) innerhalb und außerhalb der EU/EWR.<br>
                  Nissens in Dänemark und das Hauptquartier teilen personenbezogene Daten mit anderen Nissens Unternehmen,
                  wenn dies notwendig für die in Abschnitt 4 benannten Gründe ist.<br>
                  Infolgedessen können personenbezogene Daten in andere Länder sowohl innerhalb als auch außerhalb der
                  EU/EWR übertragen werden. Für die Weitergabe von Daten innerhalb der Nissens-Gruppe werden Vereinbarungen
                  auf der Grundlage der Standardverträge der Europäischen Kommission getroffen, um ein angemessenes Schutzniveau
                  für personenbezogene Daten zu gewährleisten.
                </p>
                <p>b. <span class="text-underline">Weitergabe an Dritte</span></p>
                <p>
                  Nissens übermittelt personenbezogene Daten an Dritte:
                </p>
                <ul>
                  <li>
                    Für die Erfüllung von Verträgen mit Kunden, Lieferanten und Dritten; für die Erfüllung von Nissens'
                    Verträgen (z.B. mit Händlern und Spediteuren) und für die Erfüllung von Gesetzen und behördlichen Anforderungen.
                  </li>
                  <li>
                    Dritte, die als Dienstleistungserbringer Nissens bei Lösungen (bspw. IT-Lösungen) unterstützen und als
                    Lieferanten Beratung bieten.
                  </li>
                  <li>
                    Nissens schließt nur Verträge mit professionellen Anbietern ab, die von Nissens kontinuierlich bewertet
                    werden, um sicherzustellen, dass sie die persönlichen Daten von Nissens auf einem angemessenen Schutzniveau
                    halten und sichern können.
                  </li>
                  <li>
                    Wenn ein Dritte Daten im Namen von Nissens (als Datenverantwortlicher) verarbeiten, so wird ein
                    Datenverarbeitungsvertrag geschlossen.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Verkauf personenbezogener Daten</span></p>
                <p>Nissens macht personenbezogene Daten nicht zum Gegenstand eines Verkaufs oder eines Angebots hierzu an Dritte.</p>
                <p class="semi-bold my-4 py-3">6. SICHERHEIT</p>
                <p>
                  Nissens hat geeignete technische und organisatorische Maßnahmen ergriffen und wird diese ständig
                  aktualisieren und verbessern, um zu gewährleisten und nachweisen zu können, dass das Sammeln,
                  Speichern, Verarbeiten und Löschen von persönlichen Daten in Übereinstimmung mit der geltenden
                  Gesetzgebung und diesen Datenschutzbestimmungen erfolgt. Diese Maßnahmen werden getroffen, um
                  die persönlichen Daten vor versehentlicher oder unrechtmäßiger Zerstörung, Veränderung oder
                  Verschlechterung und vor dem Zugriff unbefugter Personen auf die persönlichen Daten zu schützen.<br>
                  Nur Mitarbeiter, die im Rahmen ihrer Fähigkeit und Verantwortung zur Erfüllung ihrer Arbeitsverpflichtungen
                  tatsächlich Zugriff auf die gespeicherten personenbezogenen Daten benötigen, erhalten diesen Zugriff.
                </p>
                <p class="semi-bold my-4 py-3">7. LÖSCHUNG PERSONENBEZOGENER DATEN</p>
                <p>
                  Nissens löscht die persönlichen Daten, wenn Nissens keine betriebliche Notwendigkeit mehr für die
                  Verarbeitung der persönlichen Daten hat. Die Aufbewahrungsdauer der persönlichen Daten wird gemäß
                  den Vorgaben der bestehenden Gesetzgebung bestimmt und was notwendig ist, um Vereinbarungen mit
                  Geschäftspartnern nachzukommen, sowie um relevante Informationen in möglichen Beschwerdefällen
                  und anderen erhobenen Ansprüchen gegen oder von Nissens zu dokumentieren.
                </p>
                <p class="semi-bold my-4 py-3">8. IHRE RECHTE</p>
                <p>
                  Als Einzelperson haben Sie bestimmte Rechte in Bezug auf Ihre personenbezogenen Daten.<br>
                  Sie können sich mit Nissens in Verbindung setzen und die gewünschte Einsicht in die von Nissens
                  über Sie verarbeiteten personenbezogenen Daten erhalten, ebenso wie Sie das Recht haben, unrichtige
                  oder unangemessene Daten berichtigen zu lassen. Wenn Sie möchten, dass die personenbezogenen Daten
                  gelöscht werden, die Verarbeitung eingeschränkt wird oder Sie Einspruch gegen die Verarbeitung
                  erheben, können Sie Nissens für einen Dialog kontaktieren. Sie können sich außerdem an Nissens
                  wenden, wenn Sie von dem Recht auf Datenübertragbarkeit Gebrauch machen wollen.<br>
                  Fragen zur Verarbeitung personenbezogener Daten durch Nissens oder zu den Datenschutzbestimmungen
                  allgemein sind an folgende Email-Adressen zu richten:
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  oder <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. ÄNDERUNGEN IN DATENSCHUTZBESTIMMUNGEN VON NISSENS</p>
                <p>
                  Nissens erkennt die Verantwortung an, die Datenschutzbestimmungen regelmäßig zu überprüfen
                  und Verbesserungen und Anpassungen vorzunehmen, insbesondere um weiterhin die notwendige
                  Sicherheit in Übereinstimmung mit der Entwicklung der IT-Umgebung zu gewährleisten.
                  Nissens wird diese Datenschutzbestimmungen regelmäßig intern überprüfen und aktualisieren,
                  um die Einhaltung der geltenden Rechtsvorschriften zu gewährleisten.
                </p>
                <p class="semi-bold my-4 py-3">10. ZUSTIMMUNG ZUR KOMMUNIKATION</p>
                <p>
                  Benutzer, die ihr Konto auf den Nissens-eigenen Plattformen, einschließlich der Website
                  support.nissens.com, registrieren möchten, müssen bei der Registrierung zustimmen
                  potentielle Mitteilungen zu erhalten, die an die registrierten Benutzer der Plattform
                  verteilt werden können.
                </p>
                <p>Die Zustimmung betrifft folgende Formen von Mitteilungen</p>
                <p>Marketingmitteilungen</p>
                <p>
                  Die Benutzer erklären sich damit einverstanden, von Nissens Automotive A/S Marketingmitteilungen
                  über ihre Produkte und Dienstleistungen, Produktneuheiten, Markteinführungen und Aktualisierungen
                  sowie über Sonderaktionen, Angebote und/oder Veranstaltungen zu erhalten, die per E-Mail an die
                  Benutzer gesendet werden.
                </p>
                <p>Direkter Kontakt</p>
                <p>
                  Die Benutzer erklären sich damit einverstanden, dass sie von Nissens Automotive A/S oder/und
                  den Mitarbeitern der lokalen Tochtergesellschaften direkt kontaktiert werden, wenn sie bei der
                  Registrierung ihre E-Mail oder Telefonnummer angegeben haben, falls sie bei den auf der Plattform
                  veröffentlichten Spielen und Wettbewerben gewinnen.
                </p>
                <p>Kommunikation im Rahmen der Dienstleistung</p>
                <p>
                  Mit der Einrichtung eines Kontos auf der Plattform erklären sich die Nutzer damit einverstanden,
                  dass sie Service-E-Mails erhalten und auf anderem Wege über praktische und technische Aspekte
                  ihrer Tätigkeit auf der Plattform informiert werden.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Haftungsausschluss</h2>
              <div class="text-md">
                <p>
                  Es wurden alle möglichen Anstrengungen unternommen, um sicherzustellen, dass diese
                  Lerninformationen zum Zeitpunkt der Veröffentlichung korrekt sind. Nissens Automotive
                  A/S lehnt jedoch jede Haftung für Berechnungsfehler oder Ungenauigkeiten ab. Die
                  Materialien und Inhalte in dieser Schulung werden ohne jegliche Garantie zur Verfügung
                  gestellt. Wir empfehlen, immer die Anweisungen des Fahrzeugherstellers zu befolgen,
                  um die vorgeschriebenen Service- und Wartungsverfahren einzuhalten. Nissens Automotive
                  A/S haftet nicht für Sach- oder Personenschäden, direkte oder indirekte Schäden, die
                  durch Ausfall oder Stillstand des Fahrzeugs verursacht werden, die durch die Verwendung
                  der in dieser Schulung enthaltenen Informationen oder durch falsche Anwendung,
                  Installation und/oder Missbrauch unserer Produkte verursacht werden.
                </p>
                <p>
                  Die Werkzeuge und Fahrzeuge, die in den gemeinsamen Lernmaterialien vorgestellt werden,
                  wurden ausschließlich zu Bildungszwecken verwendet. Durch die Veröffentlichung dieses
                  Lernmaterials erhebt Nissens Automotive A/S keinen Anspruch auf das geistige Eigentum
                  der Hersteller der vorgestellten Werkzeuge, Verbrauchsmaterialien und Fahrzeuge,
                  insbesondere nicht auf deren Marken- und Modellnamen, Warenzeichen, Systeme oder Teile
                  oder deren einzigartige Eigenschaften.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Kontakt</h2>
              <div class="text-md">
                <p>
                  Diese Seite und ihre Inhalte gehören zur Nissens Automotive A/S<br>
                  &copy;Nissens Automotive A/S, alle Rechte vorbehalten.
                </p>
                <p>
                  Für weitere Fragen kontaktieren Sie:
                </p>
                <p>
                  Nissens Global Marketing<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'fr'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Politique de confidentialité des données</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1.GÉNÉRAL</p>
                <p>
                  Nissens s'engage à assurer la confidentialité, l'intégrité et la protection des
                  informations de nos employés, clients, fournisseurs et autres partenaires
                  commerciaux, y compris leurs données personnelles (ci-après dénommées par vous)
                </p>
                <p class="semi-bold my-4 py-3">2. DONNÉES PERSONNELLES COLLECTÉES ET TRAITÉES PAR NISSENS</p>
                <p>Nissens responsable du traitement lors de la collecte de données personnelles.</p>
                <p>
                  a.Général<br>
                  Nissens collecte des informations personnelles, y compris des informations sur les noms,
                  titres, adresses, numéros de téléphone, adresses e-mail et autres données d'identification
                  relatives aux clients, fournisseurs, tiers, leurs propriétaires et personnes de contact.
                  Nissens recueille l'historique des ventes, des achats et des données de formation.<br>
                  Nissens peut collecter des informations à caractéristiques financières telles que les
                  numéros de compte et les coordonnées bancaires, les passeports (copie des passeports)
                  et les numéros d'état civil, mais limités à ce qui est nécessaire conformément à la
                  législation ou sur la base d'un objectif pertinent. Les informations de cette nature
                  seront stockées avec une sécurité et un contrôle renforcés.
                </p>
                <p class="text-underline">Sur les plateformes numériques</p>
                <p>
                  Sur les sites Web appartenant à Nissens, dans la boutique en ligne de Nissens et via les
                  newsletters (uniquement avec consentement), des informations sont collectées :
                </p>
                <ul>
                  <li>Quelles pages sont visitées, quand, par conséquents, les traces de votre activité.</li>
                  <li>Quel navigateur est utilisé par le visiteur</li>
                  <li>Quelle adresse IP le visiteur a</li>
                  <li>Le nom d'utilisateur du visiteur</li>
                </ul>
                <p>Aucune autre information n'est collectée à moins qu'une notification transparente ne soit fournie au visiteur.</p>
                <p>B. Ressources Humaines</p>
                <p>
                  Nissens ne collecte pas de données personnelles, qui ont le caractère d'informations personnelles hautement
                  sensibles, telles que l'origine raciale ou ethnique, les opinions politiques, les convictions religieuses
                  ou philosophiques, les données biométriques, les données génétiques, l'orientation sexuelle, le casier
                  judiciaire ou les relations sociales.
                </p>
                <p>
                  Nissens ne collecte que des informations personnelles, qui ont le caractère d'informations personnelles
                  semi-sensibles à des fins claires, définies et transparentes, telles que l'affiliation à un syndicat,
                  des informations sur la santé et d'autres informations strictement pertinentes concernant la relation
                  et les responsabilités employeur-employé.
                </p>
                <p>
                  Concernant les employés, les candidats postulant ou en considération pour des postes chez Nissens ainsi
                  que les employés retraités, Nissens collecte des informations personnelles, telles que les noms, les numéros
                  d'état civil, les titres, les adresses, les numéros de téléphone, les adresses e-mail, les CV, les candidatures,
                  les formations documentation, transcriptions des dossiers, déclarations/recommandations, tests de personnalité,
                  photos et films (où la personne figure), résumés des évaluations de performance des employés, informations
                  sur les salaires et les impôts (lorsque la législation l'exige), informations sur la retraite, la sécurité
                  sociale ainsi comme informations de voyage. Dans ces cas, les données font l'objet d'une confidentialité et
                  d'un contrôle renforcés au sein des départements des ressources humaines et des finances de Nissens.
                </p>
                <p>
                  Pour plus d'informations sur la protection de vos données personnelles dans les processus de recrutement
                  de Nissens, veuillez contacter le service des ressources humaines de Nissens.
                </p>
                <p class="semi-bold my-4 py-3">3.CONSENTEMENT</p>
                <p>
                  Nissens ne collecte et ne traite les informations personnelles que sur une base légale et pertinente.<br>
                  Les informations personnelles sont collectées sans votre consentement, lorsqu'une licéité du traitement
                  est indiquée, ci-dessous avec une mise en balance des intérêts de vos droits et de l'intérêt légitime de Nissens.
                </p>
                <p class="semi-bold my-4 py-3">4. OBJET DES DONNÉES PERSONNELLES COLLECTÉES ET TRAITÉES</p>
                <p>
                  Nissens ne collecte et traite des données personnelles que lorsque la collecte a pour but de soutenir
                  les intérêts commerciaux légaux et légitimes de Nissens :
                </p>
                <p>a.Général</p>
                <ul>
                  <li>Pour le respect de la législation et des exigences des pouvoirs publics, y compris les actes
                    comptables, la TVA et la législation fiscale.
                  </li>
                  <li>
                    Les informations nécessaires pour remplir les accords de Nissens avec les clients, les fournisseurs
                    et les tiers, y compris la livraison et la réception du produit et/ou des services spécifiés, les
                    factures et le contrôle qualité.
                  </li>
                  <li>Contrôler et renforcer la relation avec les clients, fournisseurs et tiers existants et potentiels.</li>
                  <li>
                    Développer l'activité et les services de Nissens en identifiant les besoins des clients et les améliorations
                    souhaitées de nos services.
                  </li>
                  <li>
                    Entreprendre le traitement statistique, le développement commercial et la promotion des ventes
                    dans le respect des lois applicables.
                  </li>
                  <li>
                    Administration et contrôle des sites Web, de la boutique en ligne, des newsletters, des systèmes et des
                    applications de Nissens et via la récupération des données de ces canaux pour soutenir les objectifs ci-dessus.
                  </li>
                </ul>
                <p>b.Ressources Humaines</p>
                <ul>
                  <li>En respect du droit du travail, incluant les conditions et obligations contractuelles.</li>
                  <li>Les informations nécessaires à Nissens pour remplir le contrat de travail avec la personne concernée (employé).</li>
                  <li>Les informations nécessaires pour exercer de manière appropriée et légale les droits de gestion.</li>
                  <li>
                    Les informations nécessaires pour soutenir l'emploi de l'employé chez Nissens ainsi que le bien-être
                    et le développement de l'employé, y compris l'environnement de travail en général.
                  </li>
                  <li>Les informations nécessaires pour juger si un candidat convient à un poste chez Nissens.</li>
                  <li>Pour le respect de la législation applicable et des exigences des pouvoirs publics en matière de déclaration.</li>
                  <li>
                    Informations à l'usage du recrutement et de la fidélisation des employés chez Nissens, y compris
                    l'image de marque de l'employeur.
                  </li>
                  <li>Pour la réalisation du rapport de responsabilité sociétale</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. TRANSMISSION DES DONNÉES PERSONNELLES</p>
                <p>a. <span class="text-underline">Partage avec le groupe Nissens</span></p>
                <p>
                  Nissens est un groupe danois dont le siège est à Horsens, au Danemark, et constitue
                  un certain nombre de filiales (unités juridiques individuelles) à l'intérieur
                  et à l'extérieur de l'UE/EEE.<br>
                  Nissens au Danemark et le siège social partagent des données personnelles avec d'autres
                  sociétés Nissens, lorsque cela est nécessaire pour atteindre les objectifs mentionnés
                  à la section 4..<br>
                  En conséquence, les données personnelles peuvent être transférées vers d'autres pays à
                  l'intérieur et à l'extérieur de l'UE/EEE. Pour partager des données au sein du groupe
                  Nissens, des accords sont conclus sur la base des contrats types de la Commission européenne
                  dans le but de garantir un niveau adéquat de protection des données personnelles.
                </p>
                <p>b. <span class="text-underline">Partage avec des tiers</span></p>
                <p>
                  Nissens transmet des informations personnelles à des tiers :
                </p>
                <ul>
                  <li>
                    Pour l'exécution des accords avec les clients, les fournisseurs et les tiers ; pour le respect
                    des accords de Nissens (par exemple les distributeurs et les transporteurs) et pour le respect
                    des exigences législatives et réglementaires.
                  </li>
                  <li>
                    Des tiers qui, en tant que fournisseurs de services, assistent Nissens avec des solutions
                    (par exemple des solutions informatiques) et des fournisseurs qui assurent des tâches de conseils.
                  </li>
                  <li>
                    Nissens ne conclut des accords qu'avec des fournisseurs professionnels, que Nissens évalue en
                    permanence, garantissant qu'ils peuvent conserver et sécuriser les données personnelles de
                    Nissens à un niveau de protection adéquat.
                  </li>
                  <li>
                    Lorsqu'un tiers traite des données pour le compte de Nissens en tant que contrôleur de données,
                    un accord de traitement des données est conclu entre Nissens et le contrôleur de données.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Ventes de données personnelles</span></p>
                <p>Nissens ne rend pas les données personnelles contestables ou disponibles à la vente à des tiers.</p>
                <p class="semi-bold my-4 py-3">6. SÉCURITÉ</p>
                <p>
                  Nissens a et mettra à jour et améliorera en permanence les mesures techniques et organisationnelles
                  appropriées mises en œuvre pour garantir et être en mesure de démontrer que la collecte, le stockage,
                  le traitement et l'effacement des données personnelles sont effectués conformément à la législation
                  applicable et à la présente politique. Ces mesures sont prises pour empêcher que les données
                  personnelles ne soient détruites, modifiées ou détériorées accidentellement ou illégalement et que
                  des personnes non autorisées n'aient accès aux données personnelles.<br>
                  Seuls les employés ayant un besoin réel d'accéder aux données personnelles stockées en fonction de
                  leur capacité et de leur responsabilité à remplir leurs obligations professionnelles obtiennent cet accès.
                </p>
                <p class="semi-bold my-4 py-3">7. EFFACEMENT DES DONNÉES PERSONNELLES</p>
                <p>
                  Nissens supprime les données personnelles lorsque Nissens n'a plus de besoin professionnel de traiter
                  les données personnelles. La durée de conservation des données personnelles est déterminée en fonction
                  des obligations régies par la législation en vigueur et de ce qui est nécessaire pour remplir les
                  accords avec les partenaires commerciaux ainsi que pour documenter les informations pertinentes dans
                  les cas de plainte potentiels et autres réclamations soulevées contre ou par Nissens.
                </p>
                <p class="semi-bold my-4 py-3">8. VOS DROITS</p>
                <p>
                  En tant qu'individu, vous disposez de certains droits sur vos données personnelles.<br>
                  Vous pouvez contacter Nissens et obtenir les informations souhaitées sur les informations personnelles
                  que Nissens traite à votre sujet, tout comme vous avez le droit de faire rectifier toute donnée inexacte
                  ou inadéquate. Si vous souhaitez que les informations personnelles soient supprimées, limiter leur
                  traitement ou faire des objections contre leur traitement, vous pouvez contacter Nissens pour en discuter.
                  Vous pouvez en outre contacter Nissens si vous souhaitez exploiter le droit à la portabilité des données.<br>
                  Les questions sur le traitement des données personnelles par Nissens ou sur la politique de confidentialité
                  en général doivent être adressées par e-mail :
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a> ou
                  <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. MODIFICATIONS DE LA POLITIQUE DE CONFIDENTIALITÉ DES DONNÉES DE NISSENS</p>
                <p>
                  Nissens reconnaît la responsabilité de revoir régulièrement et d'apporter des améliorations et des
                  ajustements à la politique de confidentialité des données, en particulier pour continuer à fournir
                  la sécurité nécessaire conformément au développement de l'environnement informatique. Nissens
                  effectuera régulièrement un suivi interne et une mise à jour de cette politique de confidentialité
                  des données pour garantir le respect de la législation applicable.
                </p>
                <p class="semi-bold my-4 py-3">10. CONSENTEMENT AUX COMMUNICATIONS</p>
                <p>
                  Les utilisateurs qui souhaitent enregistrer leur compte sur les plates-formes appartenant à Nissens
                  et y compris le site Web support.nissens.com, dans le processus d'inscription doivent accepter de
                  recevoir la communication potentielle qui peut être distribuée aux utilisateurs enregistrés de la
                  plate-forme.
                </p>
                <p>Le consentement concerne les formes de communication suivantes :</p>
                <p>Communication marketing</p>
                <p>
                  Les utilisateurs acceptent de recevoir des communications marketing de Nissens Automotive A/S sur
                  leurs produits et services, les nouveautés produits, les lancements et les mises à jour ainsi que
                  sur les promotions spéciales, les offres et/ou les événements envoyés aux utilisateurs par e-mail.
                </p>
                <p>Contact direct</p>
                <p>
                  Les utilisateurs acceptent d'être contactés directement par Nissens Automotive A/S ou/et les
                  employés de leurs filiales locales s'ils ont fourni leur adresse e-mail ou leur numéro de téléphone
                  lors du processus d'inscription en cas de gain dans les jeux et concours publiés sur la plateforme.
                </p>
                <p>Service communication</p>
                <p>
                  En créant un compte sur la plateforme, les utilisateurs acceptent de recevoir des e-mails de service
                  et d'être contactés par d'autres moyens concernant les aspects pratiques et techniques de leur activité
                  au sein de la plateforme.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Avertissement</h2>
              <div class="text-md">
                <p>
                  Tous les efforts possibles ont été déployés pour s'assurer que ces informations
                  d'apprentissage sont correctes à la date de publication. Cependant, Nissens Automotive
                  A/S décline toute responsabilité en cas d'erreurs ou d'inexactitudes informatiques.
                  Le matériel et le contenu de cet apprentissage sont fournis sans garantie d'aucune sorte.
                  Nous recommandons de toujours suivre les instructions du constructeur du véhicule pour
                  se conformer aux procédures d'entretien et de maintenance exemplaires. Nissens Automotive
                  A/S ne peut être tenu responsable de tout dommage matériel ou corporel, direct ou indirect,
                  dû à une panne ou à un temps d'arrêt du fonctionnement du véhicule causé par l'utilisation
                  des informations fournies dans cet apprentissage ou par une application, une installation
                  et une / ou l'abus de nos produits.
                </p>
                <p>
                  Les outils et véhicules présentés dans les supports d'apprentissage partagés ont été utilisés
                  uniquement à des fins éducatives. En publiant ce matériel d'apprentissage, Nissens Automotive
                  A/S ne revendique aucun droit sur la propriété intellectuelle des outils, consommables et
                  constructeurs de véhicules présentés, et plus particulièrement sur leur marque et leur nom
                  de modèle, leurs systèmes ou pièces ou leurs caractéristiques uniques.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Contact</h2>
              <div class="text-md">
                <p>
                  La page et son contenu appartiennent à Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, Tous droits réservés.
                </p>
                <p>
                  Pour toute autre question, veuillez contacter
                </p>
                <p>
                  Marketing global de Nissens<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'ua'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Політика конфіденційності даних</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. ЗАГАЛЬНІ</p>
                <p>
                  Nissens прагне забезпечити конфіденційність, цілісність та захист інформації про
                  наших співробітників, клієнтів, постачальників та інших ділових партнерів, включаючи
                  їх персональні дані (далі - ви)
                </p>
                <p class="semi-bold my-4 py-3">2. ПЕРСОНАЛЬНІ ДАНІ, ЗБІРАНІ ТА ОБРОБЛЕНІ NISSENS</p>
                <p>Nissens несе відповідальність як розпорядник даних під час збору персональних даних.</p>
                <p>
                  а. Загальне<br>
                  Nissens збирає особисту інформацію, включаючи інформацію про імена, посади, адреси, номери
                  телефонів, адреси електронної пошти та інші ідентифікаційні дані, пов'язані з клієнтами,
                  постачальниками, третіми сторонами, їх власниками та контактними особами. Nissens збирає
                  історію продажів, покупок і записи про навчання.<br>
                  Nissens може збирати інформацію фінансового характеру, таку як номери рахунків та банківські
                  реквізити, паспорти (копії паспортів) та номери реєстрації актів цивільного стану, але
                  обмежуючись, якщо це необхідно відповідно до законодавства або відповідно до відповідної
                  мети. Така інформація буде зберігатися під посиленим захистом і контролем.
                </p>
                <p class="text-underline">На цифрових платформах</p>
                <p>
                  На веб-сайтах, що належать Nissens, у веб-магазині Nissens та через інформаційні бюлетені
                  (тільки за згодою) збирається інформація:
                </p>
                <ul>
                  <li>Які сайти відвідувач переглядав, коли, і, таким чином, сліди відвідувача.</li>
                  <li>Який браузер використовує відвідувач</li>
                  <li>Яку IP-адресу має відвідувач</li>
                  <li>Ім'я користувача відвідувача</li>
                </ul>
                <p>Жодна інша інформація не збирається, якщо відвідувачу не надано зрозуміле повідомлення.</p>
                <p>б. HR</p>
                <p>
                  Nissens не збирає персональні дані, які мають характер дуже конфіденційної особистої інформації,
                  як-от расове чи етнічне походження, політичні погляди, релігійні чи філософські переконання,
                  біометричні дані, генетичні дані, сексуальна орієнтація, судимість чи соціальні стосунки.
                </p>
                <p>
                  Nissens збирає особисту інформацію, яка має характер напівконфіденційної особистої інформації,
                  лише для чітких, визначених і прозорих цілей, таких як членство в профспілках, інформація про
                  стан здоров'я та іншу суворо релевантну інформацію, що стосується відносин та обов'язків між
                  роботодавцем і працівником.
                </p>
                <p>
                  Щодо співробітників, кандидатів, які претендують на посади в Nissens або розглядають їх, а також
                  пенсіонерів, Nissens збирає особисту інформацію, таку як імена, реєстраційні номери, посади, адреси,
                  номери телефонів, адреси електронної пошти, резюме, заявки, документи про освіту, розшифровки записів,
                  заяви/рекомендації, особистісні тести, фотографії та фільми (де зображена особа), підсумки оцінок
                  діяльності працівників, інформацію про заробітну плату та податки (якщо цього вимагає законодавство),
                  інформацію про пенсійне забезпечення, соціальне страхування, а також туристичну інформацію. У цих
                  випадках дані знаходяться під посиленою конфіденційністю та контролюються відповідними відділами
                  персоналу та фінансів Nissens.
                </p>
                <p>
                  Для отримання додаткової інформації про захист ваших особистих даних у процесах найму Nissens,
                  будь ласка, зв'яжіться з відділом кадрів Nissens.
                </p>
                <p class="semi-bold my-4 py-3">3. ЗГОДА</p>
                <p>
                  Nissens збирає та обробляє особисту інформацію лише на відповідній правовій основі.<br>
                  Персональна інформація збирається без вашої згоди в разі зазначення законності обробки, при
                  цьому здійснюється баланс ваших прав та законних інтересів Nissens.
                </p>
                <p class="semi-bold my-4 py-3">4. ПРИЗНАЧЕННЯ ЗІБРАНИХ ТА ОБРОБЛЕНИХ ПЕРСОНАЛЬНИХ ДАНИХ</p>
                <p>
                  Nissens збирає та обробляє персональні дані лише тоді, коли їх збирання має на меті підтримати
                  законні та комерційні інтереси Nissens:
                </p>
                <p>а. Загальне</p>
                <ul>
                  <li>Для виконання законодавства та вимог органів державної влади, у тому числі актів бухгалтерського
                    обліку, ПДВ та податкового законодавства.
                  </li>
                  <li>
                    Інформація, необхідна для виконання угод Nissens з клієнтами, постачальниками та третіми сторонами,
                    включаючи доставку та отримання зазначеного продукту та/або послуг, рахунки-фактури та контроль якості.
                  </li>
                  <li>
                    Контролювати та зміцнювати відносини з існуючими та потенційними клієнтами, постачальниками та третіми сторонами.
                  </li>
                  <li>
                    Розвивати бізнес і послуги Nissens з визначенням потреб клієнтів і бажаним покращенням наших послуг.
                  </li>
                  <li>
                    Здійснювати статистичну обробку, розвиток бізнесу та стимулювання збуту відповідно до чинного законодавства.
                  </li>
                  <li>
                    Адміністрування та контроль веб-сайтів Nissens, інтернет-магазинів, інформаційних бюлетенів, систем і програм,
                    а також отримання даних із цих каналів для підтримки вищезазначених цілей.
                  </li>
                </ul>
                <p>б. HR</p>
                <ul>
                  <li>Для виконання трудового законодавства, у тому числі договірних умов та зобов'язань.</li>
                  <li>Інформація, необхідна Nissens для виконання трудового договору з суб'єктом даних (працівником).</li>
                  <li>Необхідна інформація для належного та законного здійснення управлінських прав.</li>
                  <li>
                    Необхідна інформація для підтримки працевлаштування працівника в Nissens та добробуту та розвитку працівника,
                    включаючи робоче середовище в цілому.
                  </li>
                  <li>Необхідна інформація, щоб визначити, чи підходить кандидат для роботи в Nissens.</li>
                  <li>Для виконання вимог чинного законодавства та органів державної влади щодо звітності.</li>
                  <li>Інформація для використання найму та утримання співробітників в Nissens, включаючи бренд роботодавця.</li>
                  <li>Для виконання КСВ звітності.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. ПЕРЕДАЧА ПЕРСОНАЛЬНИХ ДАНИХ</p>
                <p>a. <span class="text-underline">Спільний доступ до Nissens Group</span></p>
                <p>
                  Nissens — це група, що належить Данії, зі штаб-квартирою в Хорсенсі, Данія, і представляє низку дочірніх
                  компаній (індивідуальних юридичних підрозділів) всередині та за межами ЄС/ЄЕЗ.<br>
                  Nissens в Данії та штаб-квартира надають персональні дані іншим компаніям Nissens, коли це необхідно для
                  досягнення цілей, зазначених у розділі 4.<br>
                  В результаті персональні дані можуть передаватися в інші країни в ЄС/ЄЕЗ, а також за їх межами. Для обміну
                  даними всередині Nissens Group укладаються угоди на основі стандартних контрактів Європейської комісії з
                  метою забезпечення належного рівня захисту персональних даних.
                </p>
                <p>b. <span class="text-underline">Спільний доступ з третіми сторонами</span></p>
                <p>
                  Nissens передає особисту інформацію третім особам:
                </p>
                <ul>
                  <li>
                    Для виконання договорів із замовниками, постачальниками та третіми особами; для виконання угод Nissens
                    (наприклад, дистриб'юторів і перевізників), а також для виконання вимог законодавства та нормативних вимог.
                  </li>
                  <li>
                    Треті сторони, які як постачальники послуг допомагають Nissens з рішеннями (наприклад, IT-рішення), а
                    постачальники надають консультації.
                  </li>
                  <li>
                    Nissens укладає угоди лише з професійними постачальниками, яких Nissens постійно оцінює, гарантуючи,
                    що вони можуть підтримувати та захищати персональні дані Nissens на належному рівні захисту.
                  </li>
                  <li>
                    Коли третя сторона обробляє дані від імені Nissens як розпорядника даних, між Nissens та обробником
                    даних укладається угода про обробку даних.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Продаж персональних даних</span></p>
                <p>Nissens не робить персональні дані доступними для продажу третім сторонам.</p>
                <p class="semi-bold my-4 py-3">6. БЕЗПЕКА</p>
                <p>
                  Nissens постійно оновлює та вдосконалює впроваджені відповідні технічні та організаційні заходи, щоб
                  забезпечити та мати можливість продемонструвати, що збирання, зберігання, обробка та стирання персональних
                  даних здійснюються відповідно до чинного законодавства та цієї політики. Ці заходи вживаються для запобігання
                  випадковому чи незаконному знищенню, зміні чи погіршенню персональних даних, а також проти отримання доступу
                  до персональних даних неавторизованими особами.<br>
                  Доступ до збережених персональних даних отримують лише працівники, які мають реальну потребу в доступі
                  до збережених персональних даних відповідно до їх можливостей та зобов'язань виконувати свої трудові обов'язки.
                </p>
                <p class="semi-bold my-4 py-3">7. ВИДАЛЕННЯ ПЕРСОНАЛЬНИХ ДАНИХ</p>
                <p>
                  Nissens видаляє персональні дані, коли Nissens більше не має професійної потреби в обробці персональних даних.
                  Термін зберігання персональних даних визначається відповідно до зобов'язань, що регулюються чинним законодавством,
                  і того, що необхідно для виконання угод з діловими партнерами, а також для документування відповідної інформації
                  у потенційних скаргах та інших претензіях, висунутих проти або з боку Nissens.
                </p>
                <p class="semi-bold my-4 py-3">8. ВАШІ ПРАВА</p>
                <p>
                  Як фізична особа, ви маєте певні права на свої персональні дані.<br>
                  Ви можете зв’язатися з Nissens і дізнатись про те, яку особисту інформацію про вас Nissens обробляє,
                  так само як ви маєте право на виправлення будь-яких неточних або невідповідних даних. Якщо ви хочете
                  видалити особисту інформацію, обмежити обробку або висловити заперечення проти обробки, ви можете
                  зв’язатися з Nissens для діалогу. Крім того, ви можете зв’язатися з Nissens, якщо бажаєте скористатися
                  правом на перенесення даних.<br>
                  Питання щодо обробки персональних даних компанією Nissens або політики конфіденційності в цілому
                  надсилайте на електронну адресу:
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  або <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. ЗМІНИ В ПОЛІТИЦІ КОНФІДЕНЦІЙНОСТІ ДАНИХ NISSENS</p>
                <p>
                  Nissens визнає відповідальність за регулярний перегляд і внесення вдосконалень та коригувань у
                  політику конфіденційності даних, особливо для продовження забезпечення необхідної безпеки відповідно
                  до розвитку ІТ-середовища. Nissens буде регулярно здійснювати внутрішні моніторинги та оновлення
                  цієї політики конфіденційності даних, щоб забезпечити відповідність чинному законодавству.
                </p>
                <p class="semi-bold my-4 py-3">10. ЗГОДА НА СПІЛКУВАННЯ</p>
                <p>
                  Користувачі, які бажають зареєструвати свій обліковий запис на платформах, що належать Nissens,
                  включаючи веб-сайт support.nissens.com, у процесі реєстрації повинні погодитися на отримання
                  потенційного повідомлення, яке може розповсюджуватися серед зареєстрованих користувачів платформи.
                </p>
                <p>Згода стосується таких форм комунікації:</p>
                <p>Маркетингова комунікація</p>
                <p>
                  Користувачі погоджуються отримувати маркетингові повідомлення від Nissens Automotive A/S про їх
                  продукти та послуги, продуктові новинки, запуски та оновлення, а також про спеціальні акції,
                  пропозиції та/або події, які надсилаються користувачам електронною поштою.
                </p>
                <p>Прямий контакт</p>
                <p>
                  Користувачі погоджуються безпосередньо зв’язуватися з Nissens Automotive A/S або/та їх місцевими
                  дочірніми працівниками, якщо вони нададуть свою електронну пошту або номер телефону під час
                  процесу реєстрації у разі перемоги в іграх та конкурсах, опублікованих на платформі.
                </p>
                <p>Сервісне повідомлення</p>
                <p>
                  Створюючи обліковий запис на платформі, користувачі погоджуються отримувати службові листи та
                  зв’язуватися з ними іншими способами щодо практичних та технічних аспектів їхньої діяльності на платформі.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Відмова від відповідальності</h2>
              <div class="text-md">
                <p>
                  Було докладено всіх можливих зусиль, щоб переконатися, що ця навчальна інформація є правильною на дату
                  випуску. Однак Nissens Automotive A/S відмовляється від будь-якої відповідальності за обчислювальні
                  помилки або неточності. Матеріали та зміст цього навчання надаються без будь-яких гарантій. Ми рекомендуємо
                  завжди дотримуватись інструкцій виробника автомобіля, щоб дотримуватись зразкових процедур обслуговування
                  та технічного обслуговування. Nissens Automotive A/S не несе відповідальності за будь-які пошкодження майна
                  або тілесні ушкодження, прямі або непрямі пошкодження через збій або простої в роботі транспортного
                  засобу, спричинені використанням інформації, наданої в цьому навчанні, або неправильним застосуванням,
                  установкою та / або зловживання нашими продуктами.
                </p>
                <p>
                  Інструменти та засоби, представлені в спільних навчальних матеріалах, використовувалися виключно в навчальних
                  цілях. Публікуючи цей навчальний матеріал, Nissens Automotive A/S не претендує на будь-які права на
                  інтелектуальну власність виробника представлених інструментів, витратних матеріалів і транспортних
                  засобів, а саме на їх марку та назву моделі, торгові марки, системи чи частини або їх унікальні
                  характеристики. .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Контакти</h2>
              <div class="text-md">
                <p>
                  Сторінка та її вміст належать Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, Усі права захищено.
                </p>
                <p>
                  З додатковими питаннями звертайтеся
                </p>
                <p>
                  Nissens Global Marketing<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'fi'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Tietosuojakäytäntö</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. YLEISTÄ</p>
                <p>
                  Nissens on sitoutunut varmistamaan työntekijöidemme, asiakkaidemme, tavarantoimittajien ja muiden
                  liikekumppaneiden tietojen luottamuksellisuuden, eheyden ja suojan, mukaan lukien heidän henkilötietonsa
                  (jäljempänä sinä)
                </p>
                <p class="semi-bold my-4 py-3">2. NISSENSIN KERÄÄMÄT JA KÄSITTELEMÄT HENKILÖTIEDOT</p>
                <p>Nissens on vastuussa rekisterinpitäjänä henkilötietojen keräämisestä.</p>
                <p>
                  a. Yleistä<br>
                  Nissens kerää henkilökohtaisia tietoja, mukaan lukien tiedot nimistä, nimikkeistä, osoitteista,
                  puhelinnumeroista, sähköpostiosoitteista ja muista asiakkaista, toimittajista, kolmansista osapuolista,
                  niiden omistajista ja yhteyshenkilöistä. Nissens kerää myynti- ja ostodataa sekä tietoja koulutuksista.<br>
                  Nissens voi kerätä tietoja taloudellisista ominaisuuksista, kuten tilinumeroista ja pankkitiedoista,
                  passeista (passin kopio) ja väestörekisterinumeroista. Tietojenkeruuta rajoitetaan tarvittaessa
                  lainsäädännön tai tarkoituksenmukaisen tarkoituksen mukaisesti. Tämän tyyppisiä tietoja säilytetään
                  tehostetussa suojauksessa ja valvonnassa.
                </p>
                <p class="text-underline">Digitaalisilla alustoilla</p>
                <p>
                  Nissensin omistamilla verkkosivuilla, Nissensin verkkokaupassa ja uutiskirjeiden kautta
                  (vain suostumuksella) kerätään tietoja:
                </p>
                <ul>
                  <li>Mitä sivustoja kävijä on katsonut ja milloin.</li>
                  <li>Mitä selainta vierailija käyttää</li>
                  <li>Mikä on vierailijan IP-osoite</li>
                  <li>Vierailijan käyttäjänimi</li>
                </ul>
                <p>Muita tietoja ei kerätä, ellei kävijälle ilmoiteta avoimesti keräämisestä.</p>
                <p>b. HR</p>
                <p>
                  Nissens ei kerää henkilötietoja, jotka ovat luonteeltaan erittäin arkaluonteisia henkilökohtaisia
                  tietoja, kuten rodullista tai etnistä alkuperää, poliittisia mielipiteitä, uskonnollisia tai filosofisia
                  uskomuksia, biometrisiä tietoja, geneettisiä tietoja, seksuaalista suuntautumista, rikosrekisteriä tai
                  sosiaalisia suhteita.
                </p>
                <p>
                  Nissens kerää vain henkilötietoja, jotka ovat luonteeltaan vähemmän arkaluonteisia selkeitä, määriteltyjä
                  ja läpinäkyviä tarkoituksia varten, kuten ammattiliittojen jäsenyys, terveystiedot ja muut työnantajan ja
                  työntekijän väliseen suhteeseen ja velvollisuuksiin liittyvät tärkeät tiedot.
                </p>
                <p>
                  Nissens kerää työntekijöistä, Nissensin työtehtäviin hakevista tai sitä harkitsevista hakijoista sekä
                  eläkkeellä olevista työntekijöistä henkilökohtaisia tietoja, kuten nimiä, kansalaisrekisterinumeroita,
                  arvoja, osoitteita, puhelinnumeroita, sähköpostiosoitteita, CV:itä, hakemuksia, tietoja koulutuksesta,
                  asiakirjat, pöytäkirjat, lausunnot/suositukset, persoonallisuustestit, valokuvat ja elokuvat (jos henkilö
                  esiintyy niissä), tiivistelmät työntekijöiden suoritusarvosteluista, palkka- ja verotiedot (jos laki vaatii),
                  tiedot eläkkeestä, sosiaaliturvasta sekä matkatiedot. Näissä tapauksissa tiedot ovat tehostetussa
                  luottamuksellisessa valvonnassa Nissensin henkilöstö- ja talousosastoilla.
                </p>
                <p>
                  Lisätietoja henkilötietojesi suojaamisesta Nissensin rekrytointiprosesseissa saat ottamalla yhteyttä
                  Nissensin HR-osastoon.
                </p>
                <p class="semi-bold my-4 py-3">3. SUOSTUMUS</p>
                <p>
                  Nissens kerää ja käsittelee henkilötietoja vain asiaankuuluvin laillisin perustein.<br>
                  Henkilötietoja kerätään ilman sinulta saatua suostumusta vain, mikäli käsittelyn laillisuus on todettu.
                  Tässä yhteydessä sinun ja Nissensin oikeutettujen etujen välinen tasapaino varmistetaan.
                </p>
                <p class="semi-bold my-4 py-3">4. KERÄTTYJEN JA KÄSITELTYJEN HENKILÖTIETOJEN TARKOITUS</p>
                <p>
                  Nissens kerää ja käsittelee henkilötietoja vain, jos keräämisellä on tarkoitus tukea Nissensin
                  laillisia ja oikeutettuja kaupallisia etuja:
                </p>
                <p>a. Yleistä</p>
                <ul>
                  <li>
                    Lainsäädäntöjen ja viranomaisvaatimusten täyttämiseen, mukaan lukien kirjanpitolaki ja laskutuslaki,
                    arvonlisävero- ja verolainsäädäntö.
                  </li>
                  <li>
                    Tarvittavat tiedot Nissensin asiakkaiden, toimittajien ja kolmansien osapuolten kanssa tekemien
                    sopimusten täyttämiseksi, mukaan lukien määritellyn tuotteen ja/tai palveluiden toimittaminen ja
                    vastaanottaminen, laskut ja laadunvalvonta.
                  </li>
                  <li>
                    Hallita ja vahvistaa suhdetta olemassa oleviin ja potentiaalisiin asiakkaisiin, toimittajiin ja
                    kolmansiin osapuoliin.
                  </li>
                  <li>
                    Kehittää Nissensin liiketoimintaa ja palveluita tunnistamalla asiakkaiden tarpeet ja halutut
                    parannukset palveluihimme.
                  </li>
                  <li>
                    Suorittaa tilastollinen käsittely, liiketoiminnan kehittäminen ja myynnin edistäminen sovellettavien
                    lakien mukaisesti.
                  </li>
                  <li>
                    Nissensin verkkosivustojen, verkkokaupan, uutiskirjeiden, järjestelmien ja sovellusten hallinta ja
                    valvonta sekä tietojen noutaminen näistä kanavista yllä mainittujen tarkoitusten tukemiseksi.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>Työlainsäädännön täyttäminen, mukaan lukien sopimusehdot ja velvoitteet.</li>
                  <li>Nissensille tarpeelliset tiedot rekisteröidyn (työntekijän) kanssa tehdyn työsopimuksen noudattamiseksi.</li>
                  <li>Tarvittavat tiedot johtamisoikeuksien asianmukaiseen ja lailliseen käyttöön.</li>
                  <li>
                    Tarvittavat tiedot, jotka tukevat työntekijän työllistymistä Nissensillä sekä työntekijän hyvinvointia
                    ja kehittymistä, mukaan lukien työympäristö yleisesti.
                  </li>
                  <li>Tarvittavat tiedot arvioidaksesi, sopiiko hakija Nissensin työtehtävään.</li>
                  <li>Voimassa olevan lainsäädännön ja viranomaisraportointivaatimusten täyttämiseksi.</li>
                  <li>Tiedot Nissensin työntekijöiden rekrytointiin ja tietojen säilyttämiseen, mukaan lukien työnantajabrändäys.</li>
                  <li>CSR-raportoinnin toteuttamiseen.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. HENKILÖTIETOJEN SIIRTO</p>
                <p>a. <span class="text-underline">Nissens Group</span></p>
                <p>
                  Nissens on tanskalaisessa omistuksessa oleva konserni, jonka pääkonttori on Horsensissa, Tanskassa.
                  Konserni koostuu useista tytäryhtiöitä (yksittäisiä juridisia yksiköitä) EU:n/ETA:n sisällä ja
                  sen ulkopuolella.<br>
                  Tanskan Nissens ja pääkonttori jakavat henkilötietoja muiden Nissens-yritysten kanssa, kun se
                  on tarpeen kohdassa 4 mainittujen tarkoitusten toteuttamiseksi.<br>
                  Tämän seurauksena henkilötietoja voidaan siirtää muihin maihin EU/ETA:n sisällä tai sen ulkopuolella.
                  Tietojen jakamiseksi Nissens Groupin sisällä tehdään Euroopan komission sopimusten pohjalta sopimuksia,
                  joiden tarkoituksena on varmistaa henkilötietojen suojan riittävä taso.
                </p>
                <p>b. <span class="text-underline">Jakaminen kolmansien osapuolten kanssa</span></p>
                <p>
                  Nissens välittää henkilötietoja kolmansille osapuolille:
                </p>
                <ul>
                  <li>
                    Asiakkaiden, tavarantoimittajien ja kolmansien osapuolten kanssa tehtyjen sopimusten täyttämiseksi;
                    Nissensin sopimusten (esimerkiksi jakelijat ja kuljettajat) sekä lainsäädännön ja säännösten
                    vaatimusten täyttämiseksi.
                  </li>
                  <li>
                    Kolmannet osapuolet, jotka palveluntarjoajana avustavat Nissensiä ratkaisuissa (esim. IT-ratkaisuissa)
                    ja konsultoinneissa.
                  </li>
                  <li>
                    Nissens tekee sopimuksia vain ammattimaisten toimittajien kanssa, joita Nissens arvioi jatkuvasti
                    varmistaakseen, että he voivat säilyttää ja suojata Nissensin henkilötietoja riittävällä suojaustasolla.
                  </li>
                  <li>
                    Kun kolmas osapuoli käsittelee tietoja Nissensin puolesta rekisterinpitäjänä, Nissensin ja tietojen
                    käsittelijän välillä tehdään tietojenkäsittelysopimus.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Henkilötietojen myynti</span></p>
                <p>Nissens ei kerää henkilötietoja kolmansille osapuolille niin, että niitä voidaan myydä eteenpäin.</p>
                <p class="semi-bold my-4 py-3">6. TURVALLISUUS</p>
                <p>
                  Nissens on päivittänyt ja tulee jatkuvasti päivittämään ja parantamaan toteutettuja asianmukaisia
                  teknisiä ja organisatorisia toimenpiteitä varmistaakseen ja pystyäkseen osoittamaan, että henkilötietojen
                  kerääminen, tallentaminen, käsittely ja poistaminen tapahtuu sovellettavan lainsäädännön ja käytäntöjen
                  mukaisesti. Näillä toimenpiteillä estetään henkilötietojen tahaton tai laiton tuhoutuminen, muuttaminen
                  sekä asiattomien pääsy henkilötietoihin.<br>
                  Pääsyn henkilötietoihin saavat vain ne työntekijät, joilla on todellinen tarve päästä käsiksi
                  tallennettuihin henkilötietoihin kykynsä ja vastuunsa mukaisesti täyttää työvelvollisuutensa.
                </p>
                <p class="semi-bold my-4 py-3">7. HENKILÖTIETOJEN POISTAMINEN</p>
                <p>
                  Nissens poistaa henkilötietoja sen jälkeen kun Nissensillä ei enää ole ammatillista tarvetta käsitellä
                  ko. tietoja. Henkilötietojen säilytysaika määräytyy voimassa olevan lainsäädännön mukaisten velvoitteiden
                  mukaisesti ja sen mukaan, mikä on tarpeen liikekumppaneiden kanssa tehtyjen sopimusten täyttämiseksi sekä
                  asiaankuuluvien tietojen dokumentoimiseksi mahdollisissa reklamaatiotapauksissa ja muissa Nissensin tai
                  Nissensiä vastaan nostetuissa vaateissa.
                </p>
                <p class="semi-bold my-4 py-3">8. OIKEUTESI</p>
                <p>
                  Yksityishenkilönä sinulla on tiettyjä oikeuksia henkilötietoihisi.<br>
                  Voit ottaa yhteyttä Nissensiin ja saada halutessasi käsityksen siitä, mitä henkilötietoja Nissensillä
                  on sinusta. Samoin sinulla on oikeus saada virheelliset tai puutteelliset tiedot oikaistuksi. Jos haluat
                  poistaa henkilötiedot, rajoittaa käsittelyä tai vastustaa niiden käyttöä, voit ottaa yhteyttä Nissensiin.
                  Voit lisäksi ottaa yhteyttä Nissensiin, jos haluat hyödyntää tiedon siirrettävyyttä.<br>
                  Nissensin henkilötietojen käsittelyä tai tietosuojakäytäntöjä koskevat kysymykset tulee lähettää
                  sähköpostitse:
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  tai <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. MUUTOKSET NISSENSIN TIETOSUOJAKÄYTÄNNÖISSÄ</p>
                <p>
                  Nissens tiedostaa vastuunsa säännöllisesti tarkistaa, tehdä parannuksia ja muutoksia
                  tietosuojakäytäntöihinsä jatkaakseen kattavan tietoturvan tarjoamista IT-ympäristön kehityksen
                  mukaisesti. Nissens suorittaa säännöllisesti tietosuojakäytäntöjen sisäistä seurantaa ja
                  päivittämistä varmistaakseen, että se noudattaa sovellettavaa lainsäädäntöä.
                </p>
                <p class="semi-bold my-4 py-3">10. VIESTINTÄSUOSTUMUS</p>
                <p>
                  Käyttäjien, jotka haluavat rekisteröidä tilinsä Nissensin omistamille alustoille, mukaan
                  lukien verkkosivusto support.nissens.com, on rekisteröintiprosessissa suostuttava vastaanottamaan
                  mahdolliset tiedot, joita voidaan jakaa alustan rekisteröidyille käyttäjille.
                </p>
                <p>Suostumus koskee seuraavia viestintälomakkeita:</p>
                <p>Markkinointikommunikaatio</p>
                <p>
                  Käyttäjät suostuvat vastaanottamaan Nissens Automotive A/S:ltä markkinointiviestintää heidän
                  tuotteistaan ja palveluistaan, tuoteuutuuksistaan, lanseerauksistaan ja päivityksistään sekä
                  käyttäjille sähköpostitse lähetetyistä erikoiskampanjoista, tarjouksista ja/tai tapahtumista.
                </p>
                <p>Suora kontaktointi</p>
                <p>
                  Käyttäjät suostuvat siihen, että Nissens Automotive A/S tai/ja heidän paikalliset tytäryhtiönsä
                  työntekijät ottavat heihin suoraan yhteyttä, jos he ovat antaneet sähköpostiosoitteensa tai
                  puhelinnumeronsa rekisteröintiprosessin aikana mikäli he voittavat palkintoja alustalla
                  julkaistuista peleistä tai kilpailuista.
                </p>
                <p>Palveluviestintä</p>
                <p>
                  Luomalla tilin alustalle käyttäjät suostuvat vastaanottamaan palvelusähköpostiviestejä sekä
                  muita viestejä, jotka koskevat heidän toimintaansa alustalla.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Vastuuvapauslauseke</h2>
              <div class="text-md">
                <p>
                  Kaikki mahdollinen on pyritty tekemään varmistaaksemme, että alustalta löytyvät oppimistiedot
                  ovat oikein niiden julkaisupäivänä. Nissens Automotive A/S ei kuitenkaan ole vastuussa mahdollisista
                  laskentavirheistä tai epätarkkuuksista. Oppimateriaalit ja sisältö tarjotaan ilman minkäänlaista
                  takuuta. Suosittelemme aina noudattamaan ajoneuvon valmistajan antamia ohjeita tarkkojen huolto- ja
                  huoltotoimenpiteiden noudattamiseksi. Nissens Automotive A/S ei ole vastuussa mistään omaisuus- tai
                  henkilövahingoista, suorista tai välillisistä vahingoista, jotka johtuvat ajoneuvon toimintahäiriöstä
                  tai seisokista, jotka ovat aiheutuneet tässä oppimateriaalissa annettujen tietojen käytöstä tai
                  virheellisestä sovelluksesta, asennuksesta ja / tai tuotteidemme väärinkäytöstä.
                </p>
                <p>
                  Yhteisissä oppimateriaaleissa esiteltyjä työkaluja ja ajoneuvoja on käytetty yksinomaan
                  opetustarkoituksiin. Julkaisemalla tämän oppimateriaalin Nissens Automotive A/S ei vaadi
                  oikeuksia esitettyjen työkalujen immateriaalioikeuksiin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Yhteystiedot</h2>
              <div class="text-md">
                <p>
                  Sivu ja sen sisältö kuuluvat Nissens Automotive A/S:lle.<br>
                  &copy;Nissens Automotive A/S 2022, Kaikki oikeudet pidätetään.
                </p>
                <p>
                  Lisäkysymyksissä ota yhteyttä
                </p>
                <p>
                  Nissens Global Markkinointi<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'ru'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Политика конфиденциальности данных</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. ОБЩИЕ ПОЛОЖЕНИЯ</p>
                <p>
                  Компания Nissens обязуется обеспечить конфиденциальность, целостность и защиту информации
                  наших сотрудников, клиентов, поставщиков и других деловых партнеров, включая их персональные
                  данные (далее - Вы или Вас).
                </p>
                <p class="semi-bold my-4 py-3">2. ПЕРСОНАЛЬНЫЕ ДАННЫЕ, СОБИРАЕМЫЕ И ОБРАБАТЫВАЕМЫЕ КОМПАНИЕЙ NISSENS</p>
                <p>Компания Nissens несет ответственность как контроллер данных при сборе персональных данных.</p>
                <p>
                  a. Общие положения<br>
                  Nissens собирает персональные данные, включая информацию об именах, названиях, адресах, номерах телефонов,
                  адресах электронной почты и другие идентификационные данные, относящиеся к клиентам, поставщикам, третьим
                  лицам, их владельцам и контактным лицам. Nissens собирает историю продаж и покупок, а также записи об
                  обучении.<br>
                  Nissens может собирать информацию о финансовых данных, таких как номера счетов и банковские реквизиты,
                  паспорта (копии паспортов) и номера актов гражданского состояния, но только в тех случаях, когда это
                  необходимо в соответствии с законодательством или исходя из соответствующих целей. Информация такого
                  рода будет храниться под усиленной охраной и контролем.
                </p>
                <p class="text-underline">На цифровых платформах</p>
                <p>
                  На принадлежащих компании Nissens веб-сайтах, в интернет-магазине Nissens и через информационные
                  бюллетени (только с согласия) собирается информация:
                </p>
                <ul>
                  <li>Какие сайты просматривал посетитель и когда</li>
                  <li>Какой браузер использует посетитель</li>
                  <li>IP-адрес посетителя</li>
                  <li>имя пользователя посетителя</li>
                </ul>
                <p>Никакая другая информация не собирается, если только посетителю не присвоен статус инкогнито</p>
                <p>b. HR</p>
                <p>
                  Компания Nissens не собирает персональные данные, которые носят характер личной информации, такой
                  как расовое или этническое происхождение, политические взгляды, религиозные или философские
                  убеждения, биометрические данные, генетические данные, сексуальная ориентация, судимость или
                  социальные отношения.
                </p>
                <p>
                  Nissens собирает личную информацию, необходимую для определённых и однозначных целей, таких как
                  членство в профсоюзе, информация о здоровье и другая строго релевантная информация, относящаяся
                  к отношениям и обязанностям работодателя и сотрудника.
                </p>
                <p>
                  В отношении сотрудников, кандидатов, претендующих или претендующих на должности в Nissens, а
                  также сотрудников, вышедших на пенсию, Nissens собирает персональную информацию, такую как
                  имена, фамилии, регистрационные номера, должности, адреса, номера телефонов, адреса электронной
                  почты, резюме, заявления, документы об образовании, выписки из протоколов, заявления/рекомендации,
                  тесты личности, фотографии и фильмы (если человек изображен на фотографии), резюме оценок работы
                  сотрудников, информацию о зарплате и налогах (когда это требуется законодательством), информацию
                  о пенсии, социальном обеспечении, а также информацию о поездках. В этих случаях данные находятся
                  под усиленными контролем и конфиденциальностью в соответствующих отделах кадров и финансов
                  компании Nissens.
                </p>
                <p>
                  Для получения дополнительной информации о защите ваших персональных данных в процессе найма
                  персонала Nissens, пожалуйста, свяжитесь с отделом кадров Nissens.
                </p>
                <p class="semi-bold my-4 py-3">3. СОГЛАСИЕ</p>
                <p>
                  Компания Nissens собирает и обрабатывает личную информацию только на соответствующем законном основании.<br>
                  Личная информация собирается без вашего согласия, если указана законность обработки, при этом соблюдается
                  баланс интересов ваших прав и законных интересов Nissens
                </p>
                <p class="semi-bold my-4 py-3">4. ЦЕЛЬ СБОРА И ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</p>
                <p>
                  Компания Nissens собирает и обрабатывает персональные данные только тогда, когда существует
                  цель их сбора для поддержки законных и обоснованных коммерческих интересов компании Nissens:
                </p>
                <p>a. Общее</p>
                <ul>
                  <li>
                    Для выполнения законодательства и требований государственных органов, включая бухгалтерские
                    акты и акты бухгалтерского учета, НДС и налоговое законодательство.
                  </li>
                  <li>
                    Необходимая информация для выполнения соглашений Nissens с клиентами, поставщиками и
                    третьими лицами, включая доставку и получение указанной продукции и или услуг, выставление
                    счетов и контроль качества.
                  </li>
                  <li>
                    Контролировать и укреплять отношения с существующими и потенциальными клиентами, поставщиками и третьими лицами.
                  </li>
                  <li>
                    Развивать бизнес и услуги Nissens с выявлением потребностей клиентов и желаемого улучшения наших услуг.
                  </li>
                  <li>
                    Проведение статистической обработки, развитие бизнеса и стимулирование продаж в соответствии
                    с действующим законодательством.
                  </li>
                  <li>
                    Администрирование и контроль веб-сайтов, интернет-магазина, информационных бюллетеней, систем и
                    приложений Nissens, а также извлечение данных из этих каналов для поддержки вышеуказанных целей.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>Для выполнения трудового законодательства, в том числе договорных условий и обязательств.</li>
                  <li>Необходимая информация для выполнения компанией Nissens трудового договора с субъектом данных (работником).</li>
                  <li>Необходимая информация для надлежащего и законного осуществления управленческих прав.</li>
                  <li>
                    Необходимая информация для поддержки занятости сотрудника в компании Nissens, его благополучия и
                    развития, включая рабочую среду в целом.
                  </li>
                  <li>Необходимая информация, позволяющая судить о том, подходит ли кандидат на должность в Nissens</li>
                  <li>Для выполнения действующего законодательства и требований государственных органов по отчетности.</li>
                  <li>
                    Информация для использования при найме и удержании сотрудников в Nissens, включая создание репутации работодателя.
                  </li>
                  <li>Для выполнения отчетности по корпоративной социальной ответственности</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ</p>
                <p>a. <span class="text-underline">Обмен с группой компаний Nissens</span></p>
                <p>
                  Компания Nissens является датской группой компаний со штаб-квартирой в г. Хорсенс,
                  Дания, и состоит из ряда дочерних компаний (отдельных юридических единиц) в странах
                  ЕС/ЕЭЗ и за их пределами..<br>
                  Nissens в Дании и штаб-квартира обмениваются персональными данными с другими компаниями
                  Nissens, когда это необходимо для выполнения целей, указанных в разделе 4.<br>
                  В результате персональные данные могут передаваться в другие страны как внутри, так и за
                  пределами ЕС/ЕЭЗ. Для обмена данными внутри группы компаний Nissens заключаются соглашения
                  на основе стандартных договоров Европейской комиссии с целью обеспечения адекватного уровня
                  защиты персональных данных.
                </p>
                <p>b. <span class="text-underline">Совместное использование с третьими лицами</span></p>
                <p>
                  Компания Nissens передает персональные данные третьим лицам:
                </p>
                <ul>
                  <li>
                    Для выполнения соглашений с клиентами, поставщиками и третьими лицами; для выполнения
                    соглашений с Nissens (например, дистрибьюторами и перевозчиками) и для выполнения законодательных
                    и нормативных требований.
                  </li>
                  <li>
                    Третьи лица, которые в качестве поставщика услуг помогают Nissens с решениями (например, IT-решения)
                    и поставщики, предоставляющие консультации.
                  </li>
                  <li>
                    Nissens заключает соглашения только с профессиональными поставщиками, которых Nissens постоянно
                    оценивает и убеждается, что они могут поддерживать и защищать персональные данные Nissens на
                    должном уровне.
                  </li>
                  <li>
                    Когда третья сторона обрабатывает данные от имени Nissens как контроллера данных, между
                    Nissens и обработчиком данных заключается соглашение об обработке данных.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Продажа персональных данных</span></p>
                <p>Nissens не делает персональные данные объектом или доступным для продажи третьим лицам.</p>
                <p class="semi-bold my-4 py-3">6. БЕЗОПАСНОСТЬ</p>
                <p>
                  Компания Nissens применяет, будет постоянно обновлять и совершенствовать соответствующие
                  технические и организационные меры, чтобы обеспечить и иметь возможность продемонстрировать,
                  что сбор, хранение, обработка и стирание персональных данных осуществляются в соответствии с
                  действующим законодательством и настоящей политикой. Эти меры принимаются для защиты персональных
                  данных от случайного или незаконного уничтожения, изменения или порчи, а также от получения
                  доступа к персональным данным неуполномоченными лицами.<br>
                  Доступ к хранящимся персональным данным получают только те сотрудники, у которых есть реальная
                  необходимость в доступе к ним в соответствии с их способностью и ответственностью выполнять
                  свои рабочие обязанности.
                </p>
                <p class="semi-bold my-4 py-3">7. УДАЛЕНИЕ ПЕРСОНАЛЬНЫХ ДАННЫХ</p>
                <p>
                  Nissens удаляет персональные данные, когда у Nissens больше нет производственной необходимости
                  в обработке персональных данных. Срок хранения персональных данных определяется в соответствии
                  с обязательствами, регулируемыми действующим законодательством, и тем, что необходимо для выполнения
                  соглашений с деловыми партнерами, а также для документирования соответствующей информации в
                  потенциальных делах по жалобам и другим предъявленным претензиям к компании Nissens или с ее стороны.
                </p>
                <p class="semi-bold my-4 py-3">8. ВАШИ ПРАВА</p>
                <p>
                  Как физическое лицо, вы обладаете определенными правами в отношении ваших персональных данных.<br>
                  Вы можете связаться с компанией Nissens и получить желаемое представление о том, какую личную
                  информацию о вас обрабатывает компания Nissens, а также вы имеете право на исправление любых
                  неточных или неадекватных данных. Если вы хотите удалить личную информацию, ограничить обработку
                  или выдвинуть возражения против обработки, вы можете обратиться в компанию Nissens для диалога.
                  Кроме того, вы можете связаться с компанией Nissens, если хотите воспользоваться правом на
                  переносимость данных.<br>
                  Вопросы, касающиеся обработки персональных данных компанией Nissens или политики конфиденциальности
                  в целом, следует направлять по электронной почте:
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  или <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. ИЗМЕНЕНИЯ В ПОЛИТИКЕ КОНФИДЕНЦИАЛЬНОСТИ ДАННЫХ КОМПАНИИ NISSENS</p>
                <p>
                  Компания Nissens признает ответственность за регулярный пересмотр и внесение улучшений и
                  корректировок в политику конфиденциальности данных, особенно для того, чтобы продолжать
                  обеспечивать необходимую безопасность в соответствии с развитием IT-среды. Nissens будет
                  регулярно проводить внутренний контроль и обновление данной политики конфиденциальности
                  данных для обеспечения соответствия действующему законодательству.
                </p>
                <p class="semi-bold my-4 py-3">10. СОГЛАСИЕ НА КОММУНИКАЦИЮ</p>
                <p>
                  Пользователи, желающие зарегистрировать свой аккаунт на принадлежащих компании Nissens платформах,
                  включая сайт support.nissens.com, в процессе регистрации должны дать согласие на получение потенциальных
                  сообщений, которые могут быть распространены среди зарегистрированных пользователей платформы.
                </p>
                <p>Согласие касается следующих форм коммуникации:</p>
                <p>Маркетинговая коммуникация</p>
                <p>
                  Пользователи соглашаются получать маркетинговые сообщения от Nissens Automotive A/S о своей продукции
                  и услугах, новинках, обновлениях, а также о специальных акциях, предложениях и/или мероприятиях,
                  направляемых пользователям по электронной почте.
                </p>
                <p>Прямой контакт</p>
                <p>
                  Пользователи соглашаются на прямую связь с Nissens Automotive A/S или/и сотрудниками их местных дочерних
                  компаний, если они указали свой адрес электронной почты или номер телефона в процессе регистрации в
                  случае выигрыша в играх и конкурсах, опубликованных на платформе.
                </p>
                <p>Коммуникация</p>
                <p>
                  Создавая учетную запись на платформе, пользователи соглашаются получать служебные электронные письма
                  и быть связанными другими способами относительно практических и технических аспектов их деятельности на платформе.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Отказ от ответственности</h2>
              <div class="text-md">
                <p>
                  Были предприняты все возможные усилия и старания, чтобы обеспечить правильность данной учебной информации
                  на дату выпуска. Однако Nissens Automotive A/S отказывается от любой ответственности за компьютерные ошибки
                  или неточности. Материалы и содержание данного учебного материала предоставляются без каких-либо гарантий.
                  Мы рекомендуем всегда следовать инструкциям производителя автомобиля для соблюдения образцовых процедур
                  обслуживания и ремонта. Nissens Automotive A/S не несет ответственности за любой материальный ущерб или
                  травмы, прямые или косвенные, в результате сбоя или простоя в работе автомобиля, вызванного использованием
                  информации, представленной в данном обучении, или неправильным применением, установкой и/или злоупотреблением
                  нашей продукцией.
                </p>
                <p>
                  Инструменты и автомобили, представленные в данном учебном материале, были использованы исключительно в
                  образовательных целях. Публикуя данный учебный материал, Nissens Automotive A/S не заявляет никаких прав
                  на интеллектуальную собственность производителя представленных инструментов, расходных материалов и
                  транспортных средств, в частности, на их марку и модель, торговые марки, системы или части, а также на их
                  уникальные особенности.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Связаться</h2>
              <div class="text-md">
                <p>
                  Данная страница и ее содержание принадлежат компании Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, Все права защищены.
                </p>
                <p>
                  По дополнительным вопросам, пожалуйста, обращайтесь
                </p>
                <p>
                  Отдел международного маркетинга Nissens<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else-if="$i18n.locale === 'cz'">
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Zásady ochrany osobních údajů</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. OBECNĚ</p>
                <p>
                  Společnost Nissens se zavazuje zajistit důvěrnost, integritu a ochranu informací od našich
                  zaměstnanců, zákazníků, dodavatelů a dalších obchodních partnerů, včetně jejich osobních údajů (dále jen vy)
                </p>
                <p class="semi-bold my-4 py-3">2. OSOBNÍ ÚDAJE SBÍRANÉ A ZPRACOVANÉ SPOLEČNOSTÍ NISSENS</p>
                <p>Společnost Nissens je odpovědná jako správce údajů při shromažďování osobních údajů.</p>
                <p>
                  a. Všeobecné<br>
                  Společnost Nissens shromažďuje osobní údaje včetně informací o jménech, titulech, adresách, telefonních
                  číslech, e-mailových adresách a dalších identifikačních údajích týkajících se zákazníků, dodavatelů, třetích
                  stran, jejich vlastníků a kontaktních osob. Společnost Nissens shromažďuje historii prodejů a nákupů a záznamy
                  o školeních.<br>
                  Společnost Nissens může shromažďovat informace o finančních charakteristikách jako jsou čísla účtů a bankovní
                  údaje, pasy (kopie pasů) a čísla občanského průkazu, ale s omezením tam, kde je to nutné podle legislativy
                  nebo na základě relevantního účelu. Tato povaha informací bude uchovávána pod posíleným zabezpečením a kontrolou.
                </p>
                <p class="text-underline">Na digitálních platformách</p>
                <p>Na webových stránkách vlastněných společností Nissens, v internetovém obchodě společnosti Nissens a
                  prostřednictvím newsletterů, pouze se souhlasem se shromažďováním informací:</p>
                <ul>
                  <li>Které stránky si návštěvník prohlížel, kdy a tím i stopu návštěvníka.</li>
                  <li>Jaký prohlížeč návštěvník používá</li>
                  <li>Jakou IP adresu má návštěvník</li>
                  <li>Uživatelské jméno návštěvníka</li>
                </ul>
                <p>Žádné další informace nejsou shromažďovány, pokud není návštěvníkovi poskytnuto transparentní upozornění.</p>
                <p>b. HR</p>
                <p>
                  Nissens neshromažďuje osobní údaje, které mají charakter vysoce citlivých osobních údajů, jako je
                  rasový nebo etnický původ, politické názory, náboženské nebo filozofické přesvědčení, biometrické
                  údaje, genetické údaje, sexuální orientace, záznam v trestním rejstříku nebo sociální vztahy.
                </p>
                <p>
                  Společnost Nissens shromažďuje pouze osobní údaje, které mají charakter polocitlivých osobních údajů
                  pro jasné, definované a transparentní účely, jako je členství v odborech, informace o zdraví a další
                  přísně relevantní informace související se vztahem a povinnostmi zaměstnavatele a zaměstnance.
                </p>
                <p>
                  Pokud jde o zaměstnance, kandidáty, kteří se ucházejí o pracovní pozice ve společnosti Nissens nebo
                  o ně uvažují, jakož i zaměstnance v důchodu, tak společnost Nissens shromažďuje osobní údaje jako
                  jsou jména, rodná čísla, tituly, adresy, telefonní čísla, e-mailové adresy, životopisy, žádosti,
                  vzdělání, přepisy záznamů, prohlášení/doporučení, testy osobnosti, fotografie a filmy (kde osoba
                  vystupuje), souhrny hodnocení výkonu zaměstnanců, informace o platu a daních (pokud to vyžaduje
                  legislativa), informace o důchodu, sociálním zabezpečení i cestovní informace. V těchto případech
                  jsou data pod zvýšenou důvěrností a kontrolou v rámci příslušných personálních a finančních oddělení
                  společnosti Nissens.
                </p>
                <p>
                  Pro více informací o ochraně vašich osobních údajů v náborových procesech společnosti Nissens
                  kontaktujte personální oddělení společnosti Nissens.
                </p>
                <p class="semi-bold my-4 py-3">3. SOUHLAS</p>
                <p>
                  Společnost Nissens shromažďuje a zpracovává osobní údaje pouze na relevantním právním základě.<br>
                  Osobní údaje jsou shromažďovány bez vašeho souhlasu, kde je uvedena zákonnost zpracování, dále s
                  vyvážením zájmů vašich práv a oprávněného zájmu Nissens.
                </p>
                <p class="semi-bold my-4 py-3">4. ÚČEL SBÍRANÝCH A ZPRACOVANÝCH OSOBNÍCH ÚDAJŮ</p>
                <p>
                  Společnost Nissens shromažďuje a zpracovává osobní údaje pouze tehdy, existuje-li účel jejich
                  shromažďování na podporu zákonných a oprávněných obchodních zájmů společnosti Nissens:
                </p>
                <p>A. Všeobecné</p>
                <ul>
                  <li>
                    Pro plnění legislativy a požadavků orgánů veřejné moci včetně zákonů o vedení účetnictví a
                    účetních zákonů, DPH a daňové legislativy.
                  </li>
                  <li>
                    Nezbytné informace k plnění smluv společnosti Nissens se zákazníky, dodavateli a třetími
                    stranami včetně dodání a příjmu specifikovaného produktu nebo služeb, faktur a kontroly kvality.
                  </li>
                  <li>
                    Kontrolovat a posilovat vztah se stávajícími a potenciálními zákazníky, dodavateli a třetími stranami.
                  </li>
                  <li>
                    Rozvíjet podnikání a služby společnosti Nissens s identifikací potřeb zákazníků a požadovaných
                    zlepšení našich služeb.
                  </li>
                  <li>
                    Provádět statistické zpracování, rozvoj podnikání a podporu prodeje v souladu s platnými zákony.
                  </li>
                  <li>
                    Správa a kontrola webových stránek, internetového obchodu, newsletterů, systémů a aplikací
                    společnosti Nissens a prostřednictvím získávání dat z těchto kanálů k podpoře výše uvedených účelů.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>K plnění pracovněprávních předpisů včetně smluvních podmínek a povinností.</li>
                  <li>Nezbytné informace pro Nissens k plnění pracovní smlouvy se subjektem (zaměstnancem).</li>
                  <li>Nezbytné informace k řádnému a zákonnému výkonu manažerských práv.</li>
                  <li>
                    Nezbytné informace pro podporu zaměstnání zaměstnance ve společnosti Nissens a pro blaho a rozvoj
                    zaměstnance včetně pracovního prostředí obecně.
                  </li>
                  <li>Potřebné informace k posouzení, zda je kandidát vhodný na pracovní pozici ve společnosti Nissens.</li>
                  <li>Pro splnění požadavků platných právních předpisů a orgánů veřejné moci na podávání zpráv.</li>
                  <li>Informace pro využití náboru a udržení zaměstnanců ve společnosti Nissens včetně značky zaměstnavatele.</li>
                  <li>Pro plnění CSR reportingu.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. PŘEDÁNÍ OSOBNÍCH ÚDAJŮ</p>
                <p>a. <span class="text-underline">Sdílení se skupinou Nissens</span></p>
                <p>
                  Nissens je dánská skupina se sídlem v Horsens v Dánsku a tvoří řadu dceřiných společností
                  (jednotlivě právní jednotky) v EU/EHP i mimo ni.<br>
                  Společnost Nissens v Dánsku a ústředí sdílejí osobní údaje s jinými společnostmi Nissens,
                  pokud je to nezbytné pro splnění účelů uvedených v části 4.<br>
                  V důsledku toho mohou být osobní údaje přenášeny do jiných zemí v rámci EU/EHP i mimo ně. Ke
                  sdílení dat v rámci skupiny Nissens jsou uzavírány smlouvy na základě standardních smluv
                  Evropské komise s cílem zajistit odpovídající úroveň ochrany osobních údajů.
                </p>
                <p>b. <span class="text-underline">Sdílení s třetími stranami</span></p>
                <p>
                  Společnost Nissens předává osobní údaje třetím stranám:
                </p>
                <ul>
                  <li>
                    Pro plnění dohod se zákazníky, dodavateli a třetími stranami; pro plnění smluv Nissens
                    (například distributoři a přepravci) a pro plnění legislativních a regulačních požadavků.
                  </li>
                  <li>
                    Třetí strany, které jako dodavatel služeb pomáhají společnosti Nissens s řešeními (například
                    IT řešení) a dodavatelé poskytující poradenství.
                  </li>
                  <li>
                    Společnost Nissens uzavírá smlouvy pouze s profesionálními dodavateli, které společnost
                    Nissens průběžně vyhodnocuje a zajišťuje, že mohou uchovávat a zabezpečit osobní údaje
                    společnosti Nissens na odpovídající úrovni ochrany.
                  </li>
                  <li>
                    Pokud třetí strana zpracovává údaje jménem společnosti Nissens jako správce údajů, je mezi
                    společností Nissens a zpracovatelem údajů uzavřena dohoda o zpracování údajů.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Prodej osobních údajů</span></p>
                <p>Společnost Nissens nenabízí osobní údaje ani je nezpřístupňuje k prodeji třetím stranám.</p>
                <p class="semi-bold my-4 py-3">6. ZABEZPEČENÍ</p>
                <p>
                  Společnost Nissens má a bude neustále aktualizovat a vylepšovat zavedená vhodná technická a
                  organizační opatření, aby zajistila a byla schopna prokázat, že shromažďování, uchovávání,
                  zpracovávání a mazání osobních údajů probíhá v souladu s platnou legislativou a těmito zásadami.
                  Tato opatření jsou učiněna, aby se zabránilo náhodnému nebo nezákonnému zničení, změnám nebo
                  zhoršení osobních údajů a aby se k osobním údajům nedostaly neoprávněné osoby.<br>
                  Tento přístup mají pouze zaměstnanci, kteří skutečně potřebují přístup k uloženým osobním
                  údajům v souladu se svými schopnostmi a odpovědností plnit své pracovní povinnosti.
                </p>
                <p class="semi-bold my-4 py-3">7. VÝMAZ OSOBNÍCH ÚDAJŮ</p>
                <p>
                  Společnost Nissens provádí výmaz osobních údajů, pokud společnost Nissens již nemá pracovní
                  potřebu zpracovávat osobní údaje. Doba uchovávání osobních údajů je stanovena v souladu s
                  povinnostmi upravenými stávající legislativou a tím, co je nezbytné pro plnění dohod s obchodními
                  partnery, jakož i pro doložení relevantních informací v případných stížnostech a jiných vznesených
                  nárocích vůči společnosti Nissens nebo ze strany společnosti Nissens.
                </p>
                <p class="semi-bold my-4 py-3">8. VAŠE PRÁVA</p>
                <p>
                  Jako fyzická osoba máte určitá práva ohledně svých osobních údajů.<br>
                  Můžete kontaktovat společnost Nissens a získat požadovaný přehled o tom, jaké osobní
                  údaje o vás společnost Nissens zpracovává, stejně jako máte právo na opravu jakýchkoli
                  nepřesných nebo neadekvátních údajů. Pokud si přejete osobní údaje smazat, omezit zpracování
                  nebo vznést námitky proti zpracování, můžete se obrátit na Nissens s žádostí o změnu.
                  Pokud si přejete využít práva na přenositelnost údajů, můžete se dále obrátit na
                  společnost Nissens.<br>
                  Dotazy ke zpracování osobních údajů společností Nissens nebo k zásadám ochrany osobních údajů
                  obecně směřujte na e-mail:
                  <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  nebo <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. ZMĚNY V ZÁSADÁCH OCHRANY ÚDAJŮ NISSENS</p>
                <p>
                  Společnost Nissens uznává odpovědnost za pravidelnou kontrolu a provádění vylepšování a
                  úprav zásad ochrany osobních údajů zejména proto, aby nadále poskytovala nezbytné zabezpečení
                  v souladu s vývojem prostředí IT. Společnost Nissens bude pravidelně provádět interní sledování
                  a aktualizaci těchto zásad ochrany osobních údajů, aby zajistila soulad s platnou legislativou.
                </p>
                <p class="semi-bold my-4 py-3">10. KOMUNIKAČNÍ SOUHLAS</p>
                <p>
                  Uživatelé, kteří si chtějí zaregistrovat svůj účet na platformách vlastněných společností Nissens
                  včetně webové stránky support.nissens.com, musí v procesu registrace souhlasit s přijímáním potenciální
                  komunikace, která může být distribuována pouze registrovaným uživatelům platformy.
                </p>
                <p>Souhlas se týká následujících komunikačních forem:</p>
                <p>Marketingová komunikace</p>
                <p>
                  Uživatelé souhlasí s přijímáním marketingových sdělení od společnosti Nissens Automotive
                  A/S o jejich produktech a službách, produktových novinkách, uvedení na trh a aktualizacích,
                  jakož i o speciálních akcích, nabídkách nebo událostech zasílaných uživatelům e-mailem.
                </p>
                <p>Přímý kontakt</p>
                <p>
                  Uživatelé souhlasí s tím, že budou kontaktováni přímo společností Nissens Automotive A/S nebo
                  zaměstnanci jejích místních dceřiných společností v případě, že během registračního procesu
                  poskytli svůj e-mail nebo telefonní číslo pro případ výhry z her a soutěží zveřejněných na platformě.
                </p>
                <p>Servisní komunikace</p>
                <p>
                  Vytvořením účtu na platformě uživatelé souhlasí s přijímáním servisních e-mailů a s tím,
                  že budou kontaktováni jinými prostředky ohledně praktických a technických aspektů jejich
                  činnosti v rámci platformy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Zřeknutí se odpovědnosti</h2>
              <div class="text-md">
                <p>
                  Bylo vynaloženo veškeré možné úsilí, aby bylo zajištěno, že tyto výukové informace jsou správné
                  k datu vydání. Společnost Nissens Automotive A/S se však zříká jakékoli odpovědnosti za výpočetní
                  chyby nebo nepřesnosti. Materiály a obsah na tomto portálu jsou poskytovány bez záruky jakéhokoliv
                  druhu. Doporučujeme vždy postupovat podle pokynů výrobce vozidla dle vzorových postupů obsluhy a
                  údržby. Společnost Nissens Automotive A/S nenese odpovědnost za žádné škody na majetku nebo zranění
                  osob, přímé nebo nepřímé škody v důsledku poruchy nebo prostoje v provozu vozidla způsobeného
                  použitím informací uvedených na tomto portálu nebo nesprávnou aplikací, montáží nebo zneužití
                  našich produktů.
                </p>
                <p>
                  Nástroje a vozidla prezentovaná ve sdílených učebních materiálech byly použity výhradně pro vzdělávací
                  účely. Zveřejněním tohoto výukového materiálu si společnost Nissens Automotive A/S nenárokuje žádná
                  práva k duševnímu vlastnictví výrobců prezentovaných nástrojů, spotřebního materiálu a vozidel a to
                  konkrétně k jejich značce a názvu modelu, obchodním známkám, systémům nebo dílům nebo jejich
                  jedinečným vlastnostem.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Kontakt</h2>
              <div class="text-md">
                <p>
                  Stránka a její obsah patří společnosti Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, Všechna práva vyhrazena.
                </p>
                <p>
                  V případě dalších dotazů nás prosím kontaktujte
                </p>
                <p>
                  Globální marketing společnosti Nissens<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-else>
      <section id="privacy-policy" class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h1 class="text-primary text-xl bold mb-4">Data Privacy Policy</h1>
              <div class="text-md">
                <p class="semi-bold my-4 py-3">1. GENERAL</p>
                <p>
                  Nissens is committed to ensuring the confidentiality, integrity and protection of information
                  from our employees, customers, suppliers and other business partners,
                  including their personal data (hereinafter referred to as you)
                </p>
                <p class="semi-bold my-4 py-3">2. PERSONAL DATA COLLECTED AND PROCESSED BY NISSENS</p>
                <p>Nissens is responsible as data controller when collecting personal data.</p>
                <p>
                  a. General<br>
                  Nissens collects personal information, including information about names, titles, addresses,
                  telephone numbers, e-mail addresses and other identification data related to customers,
                  suppliers, third parties, their owners and contact persons. Nissens collect sales- and
                  purchase history and training records.<br>
                  Nissens can collect information about financial characteristics such as account numbers
                  and bank details, passports (copy of passports) and civil registration numbers, but
                  limited to where necessary according to legislation or based on relevant purpose. This
                  nature of information will be stored under intensified security and control.
                </p>
                <p class="text-underline">On digital platforms</p>
                <p>On Nissens' owned websites, in Nissens' webshop and via newsletters (only with consent) information is collected:</p>
                <ul>
                  <li>Which sites the visitor has been looking at, when, and thereby the visitor's tracks.</li>
                  <li>Which browser the visitor is using</li>
                  <li>Which IP address the visitor has</li>
                  <li>The username of the visitor</li>
                </ul>
                <p>No other information is collected unless transparent notification is provided to the visitor.</p>
                <p>b. HR</p>
                <p>
                  Nissens does not collect personal data, which has the character of highly sensitive personal information,
                  such as racial or ethnic origin, political opinions, religious or philosophical beliefs, biometric data,
                  genetic data, sexual orientation, criminal record or social relationships.
                </p>
                <p>
                  Nissens only collects personal information, which has the character of semi-sensitive personal information
                  for clear, defined and transparent purposes, such as trade union memberships, health information and
                  other strictly relevant information pertinent to the employer-employee relationship and responsibilities.
                </p>
                <p>
                  Concerning employees, candidates applying for or in consideration for job positions at Nissens
                  as well as retired employees, Nissens collects personal information, such as names, civil
                  registration numbers, titles, addresses, telephone numbers, e-mail addresses, CVs, applications,
                  education documentation, transcripts of records, statements/recommendations, personality tests,
                  photos and movies (where the person is featuring), summaries of performance reviews about
                  employees, salary and tax information (when required by legislation), information regarding
                  pension, social security as well as travel information. In these cases, the data is under
                  intensified confidentiality and control within Nissens' relevant HR and Finance Departments.
                </p>
                <p>
                  For more information about protection of your personal data in Nissens' recruitment processes,
                  please contact Nissens' HR department.
                </p>
                <p class="semi-bold my-4 py-3">3. CONSENT</p>
                <p>
                  Nissens is only collecting and processing personal information on relevant legal basis.<br>
                  Personal information is collected without a consent from you, where a lawfulness of the processing
                  is stated, hereunder with a balancing of the interests of the rights of yours and Nissens'
                  legitimate interest is made.
                </p>
                <p class="semi-bold my-4 py-3">4. PURPOSE OF THE COLLECTED AND PROCESSED PERSONAL DATA</p>
                <p>
                  Nissens only collects and processes personal data, when there is a purpose for the
                  collection to support the legal and legitimate commercial interests of Nissens:
                </p>
                <p>a. General</p>
                <ul>
                  <li>For the fulfilment of legislation and requirements of the public authorities, including
                    bookkeeping acts and accounting acts, VAT and tax legislation.
                  </li>
                  <li>
                    The necessary information to fulfill Nissens' agreements with customers, suppliers and third
                    parties, including delivering and receiving the specified product and or services, invoices and quality control.
                  </li>
                  <li>To control and strengthen the relationship to existing and potential customers, suppliers and third parties.</li>
                  <li>
                    Develop Nissens' business and services with an identification of customer needs and the desired
                    improvements of our services.
                  </li>
                  <li>
                    Undertake statistical processing, business development and sales promotion under the compliance of applicable laws.
                  </li>
                  <li>
                    Administration and controlling of Nissens' websites, webshop, newsletters, systems and applications
                    and via retrieving data from these channels to support the above purposes.
                  </li>
                </ul>
                <p>b. HR</p>
                <ul>
                  <li>To the fulfilment of employment law, including contractual conditions and obligations.</li>
                  <li>The necessary information for Nissens to fulfill the employment agreement with the data subject (employee).</li>
                  <li>The necessary information to appropriately and legally exercise the managerial rights.</li>
                  <li>
                    The necessary information to support the employee's employment at Nissens and the welfare and development of
                    the employee, including the working environment in general.
                  </li>
                  <li>The necessary information to judge whether a candidate is suitable for a job position at Nissens.</li>
                  <li>For the fulfilment of applicable legislation and the public authorities requirements of reporting.</li>
                  <li>Information for the use of recruitment and retention of employees at Nissens, including employer branding.</li>
                  <li>For the fulfilment of CSR reporting.</li>
                </ul>
                <p class="semi-bold my-4 py-3">5. TRANSMISSION OF PERSONAL DATA</p>
                <p>a. <span class="text-underline">Sharing with the Nissens Group</span></p>
                <p>
                  Nissens is a Danish owned group with its HQ in Horsens, Denmark, and constitutes a
                  number of subsidiaries (individually legal units) inside and outside EU/EEA.<br>
                  Nissens in Denmark and the HQ share personal data with other Nissens companies,
                  when it is necessary to fulfil the purposes mentioned in section 4.<br>
                  As a result, personal data may be transferred to other countries inside as well as
                  outside the EU/EEA. To be sharing data within the Nissens Group, agreements are made
                  based on the European Commission's standard contracts with the purpose of securing an
                  adequate level of protection of personal data.
                </p>
                <p>b. <span class="text-underline">Sharing with third parties</span></p>
                <p>
                  Nissens is transmitting personal information to third parties:
                </p>
                <ul>
                  <li>
                    For the fulfilment of agreements with customers, suppliers and third parties; for the
                    fulfilment of Nissens' agreements (for example distributors and carriers) and for the
                    fulfilment of legislation and regulatory requirements.
                  </li>
                  <li>
                    Third parties, who as a service supplier assist Nissens with solutions (for example IT-solutions)
                    and suppliers providing consulting.
                  </li>
                  <li>
                    Nissens only enters into agreements with professional suppliers, whom Nissens continuously
                    evaluates, securing that they can maintain and secure Nissens' personal data to an
                    adequate level of protection.
                  </li>
                  <li>
                    When a third party is processing data om behalf of Nissens as a data controller, a
                    data processor agreement is made between Nissens and the data processor.
                  </li>
                </ul>
                <p>c. <span class="text-underline">Sales of personal data</span></p>
                <p>Nissens is not making personal data object to or available for sale to third parties.</p>
                <p class="semi-bold my-4 py-3">6. SECURITY</p>
                <p>
                  Nissens has and will continuously update and improve implemented appropriate
                  technical and organizational measures to ensure and to be able to demonstrate
                  that the collecting, storing, processing and erasure of personal data are performed
                  in accordance with the applicable legislation and this policy. These measures are
                  made to prevent personal data against accidental or illegal destruction, changes
                  or deterioration and from unauthorized persons getting access to the personal data.<br>
                  Only employees with an actual need of access to the stored personal data in accordance
                  of their ability and liability to fulfill their work obligations are getting this access.
                </p>
                <p class="semi-bold my-4 py-3">7. ERASURE OF PERSONAL DATA</p>
                <p>
                  Nissens is deleting personal data, when Nissens no longer has an occupational need
                  for processing the personal data. The period of storage of the personal data is
                  determined according to the obligations governed by existing legislation and what
                  is necessary to fulfil agreements with business partners as well as to document
                  relevant information in potential complaint cases and other raised claims against
                  or by Nissens.
                </p>
                <p class="semi-bold my-4 py-3">8. YOUR RIGHTS</p>
                <p>
                  As individual, you have certain rights over your personal data.<br>
                  You can contact Nissens and get the desired insight into which personal information
                  that Nissens is processing about you, just as you are entitled to have any inaccurate
                  or inadequate data rectified. If you want the personal information deleted, limit the
                  processing or make objections against the processing, you can contact Nissens for a
                  dialogue. You can furthermore contact Nissens, if you wishes to exploit the right of
                  data portability.<br>
                  Questions to Nissens' processing of personal data or to the privacy policy in general
                  shall be directed to e-mail: <a href="mailto:databeskyttelse@nissens.com">databeskyttelse@nissens.com</a>
                  or <a href="mailto:dataprivacy@nissens.com">dataprivacy@nissens.com</a>
                </p>
                <p class="semi-bold my-4 py-3">9. CHANGES IN NISSENS' DATA PRIVACY POLICY</p>
                <p>
                  Nissens acknowledges the responsibility of regularly reviewing and making improvements and
                  adjustments to the data privacy policy, especially to continue to provide the necessary
                  security in line with the development of the IT-environment. Nissens will regularly perform
                  internal follow-up and update of this data privacy policy to secure compliance with the
                  applicable legislation.
                </p>
                <p class="semi-bold my-4 py-3">10. COMMUNICATION CONSENT</p>
                <p>
                  Users who wish to register their account at Nissens' owned platforms and including the
                  website support.nissens.com, in the registration process must agree to receive the potential
                  communication that may be distributed to the platform's registered users.
                </p>
                <p>The consent regards the following communication forms:</p>
                <p>Marketing communication</p>
                <p>
                  Users agree to receive marketing communication from Nissens Automotive A/S about their
                  product and services, product novelties, launches and updates as well as about special
                  promotions, offers and/or events sent to users by email.
                </p>
                <p>Direct contact</p>
                <p>
                  Users agree to be contacted by Nissens Automotive A/S or/and their local subsidiary employees
                  directly in case they have provided their email or phone number during the registration process
                  in case of winning from games and contests published at the platform.
                </p>
                <p>Service communication</p>
                <p>
                  By creating an account at the platform users agree to receive service emails and
                  to be contacted by other means regarding practical and technical aspects of
                  their activity within the platform.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="disclaimer" class="my-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Disclaimer</h2>
              <div class="text-md">
                <p>
                  Every possible effort and endeavor has been made to ensure that this learning information
                  is correct at the date of issue. Nissens Automotive A/S, however, disclaims any liability
                  for computing errors or inaccuracies. The materials and contents in this learning are
                  provided without warranty of any kind. We recommend always following the given vehicle
                  manufacturer's instructions to comply with the exemplary service and maintenance procedures.
                  Nissens Automotive A/S shall not be held responsible for any property damage or personal
                  injury, direct or indirect damage, due to failure or downtime in the vehicle's operation
                  caused by use of the information provided in this learning or by incorrect application,
                  installation, and / or abuse of our products.
                </p>
                <p>
                  The tools and vehicles presented in the shared learning materials have been used solely for
                  educational purposes. By publishing this learning material, Nissens Automotive A/S does not
                  claim any rights to the intellectual property of the presented tools', consumables' and
                  vehicle's manufacturer, and specifically to their make and model name, trademarks, systems
                  or parts or their unique features.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" class="mt-5">
        <div class="container">
          <div class="row">
            <div class="col-xl-9">
              <h2 class="text-primary text-xl bold mb-5">Contact</h2>
              <div class="text-md">
                <p>
                  The page and its contents belongs to Nissens Automotive A/S.<br>
                  &copy;Nissens Automotive A/S 2022, All rights reserved.
                </p>
                <p>
                  For further questions, please contact
                </p>
                <p>
                  Nissens Global Marketing<br>
                  <a href="mailto:experts@nissens.com">experts@nissens.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t('menu.privacyPolicy'),
    };
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
a {
  color: $secondary;
  &:hover {
    color: $secondary;
    text-decoration: underline;
  }
}
</style>
